// Web CRM (Business plane) i18n dictionary — COMPLETE-A batch. STATIC UI CHROME ONLY.
// Merged into the flat per-language lookup by ./translations.js (same t() semantics, no new dep).
//
// SCOPE: remaining visible static labels on ShowroomManager and CreateSurvey pages.
// NEVER used for dynamic/backend/user content (customer/business/product names, prices, emails,
// phones, category ids, ratings, counts, dates, err.detail/error.message). Common buttons/status
// reuse the `common.*` keys. English is the default + fallback; every language carries the
// IDENTICAL key set. Interpolation tokens: {name} {count} {error} {customer} {action}
// {business} {n}.

const pagesCompleteATranslations = {
  en: {
    // ---- ShowroomManager ----
    'pca.sm.productPublished': 'Product published',
    'pca.sm.correctionRequested': 'Correction requested',
    'pca.sm.correctionAccepted': 'Correction accepted',
    'pca.sm.showroomRequiredHint': 'Create your Showroom before adding Marketplace items.',
    'pca.sm.correctionAwaitingReview': 'Correction submitted — awaiting review',
    'pca.sm.correctionRequestedAt': 'Requested',
    'pca.sm.correctionEditHint': 'Edit this listing to address the request, then save.',
    'pca.sm.correctionSubmittedHint': 'Your update has been submitted. Servisfy will review it.',
    'pca.sm.productHidden': 'Product hidden',
    'pca.sm.productNowActive': '{name} is now active.',
    'pca.sm.productNowHidden': '{name} is now hidden.',
    'pca.sm.updateFailed': 'Update failed',
    'pca.sm.confirmDeleteProduct': 'Delete "{name}"? This cannot be undone.',
    'pca.sm.productDeleted': 'Product deleted',
    'pca.sm.productWasRemoved': '{name} was removed.',
    'pca.sm.deleteFailed': 'Delete failed',
    'pca.sm.formError': 'Form Error',
    'pca.sm.formNotInit': 'Form data is not properly initialized.',
    'pca.sm.validationError': 'Validation Error',
    'pca.sm.fillRequiredFields': 'Please fill in all required fields.',
    'pca.sm.authError': 'Authentication Error',
    'pca.sm.businessIdRequiredLogin': 'User business ID is required. Please log in again.',
    'pca.sm.showroomUpdated': 'Showroom Updated',
    'pca.sm.showroomUpdatedDesc': 'Your showroom details have been updated successfully!',
    'pca.sm.showroomCreated': 'Showroom Created',
    'pca.sm.showroomCreatedDesc': 'Your showroom has been created successfully!',
    'pca.sm.failedSaveShowroom': 'Failed to save showroom. Please try again.',
    'pca.sm.productNameDescRequired': 'Product name and description are required.',
    'pca.sm.categoryRequired': 'Category Required',
    'pca.sm.selectCategoryBeforeSaving': 'Please select a product category before saving.',
    'pca.sm.functionNotAvailable': 'Function Not Available',
    'pca.sm.productCreateFnUnavailable': 'Product creation function is not available. Please refresh the page.',
    'pca.sm.productAddedTitle': 'Product Added Successfully',
    'pca.sm.productAddedDesc': '{name} has been added to your showroom and is now visible in Product & Services.',
    'pca.sm.errorAddingProduct': 'Error Adding Product',
    'pca.sm.failedAddProduct': 'Failed to add product: {error}',
    'pca.sm.unknownErrorOccurred': 'Unknown error occurred',
    'pca.sm.unknownError': 'Unknown error',
    'pca.sm.tooManyImages': 'Too Many Images',
    'pca.sm.selectUpTo10': 'Please select up to 10 images total.',
    'pca.sm.unsupportedFile': 'Unsupported file',
    'pca.sm.onlyImageTypes': '{name}: only JPEG, PNG or WebP images are allowed.',
    'pca.sm.fileTooLarge': 'File too large',
    'pca.sm.imageMaxSize': '{name}: images must be 10MB or smaller.',
    'pca.sm.imagesUploaded': 'Images uploaded',
    'pca.sm.imagesAdded': '{count} image(s) added.',
    'pca.sm.uploadFailed': 'Upload failed',
    'pca.sm.couldNotUploadImage': 'Could not upload image.',
    'pca.sm.onlyVideoTypes': '{name}: only MP4 or MOV videos are allowed.',
    'pca.sm.videoMaxSize': '{name}: videos must be 100MB or smaller.',
    'pca.sm.videoUploaded': 'Video uploaded',
    'pca.sm.productVideoAdded': 'Product video added.',
    'pca.sm.couldNotUploadVideo': 'Could not upload video.',
    'pca.sm.productUpdateFnUnavailable': 'Product update function is not available. Please refresh the page.',
    'pca.sm.productUpdated': 'Product Updated',
    'pca.sm.productUpdatedDesc': '{name} has been updated successfully.',
    'pca.sm.errorUpdatingProduct': 'Error Updating Product',
    'pca.sm.failedUpdateProduct': 'Failed to update product: {error}',
    'pca.sm.imagesUploadedTitle': 'Images Uploaded',
    'pca.sm.imagesUploadedComingSoon': '{count} image(s) uploaded. Showroom gallery attachment is coming soon.',
    'pca.sm.uploadFailedTitle': 'Upload Failed',
    'pca.sm.couldNotUploadImages': 'Could not upload image(s). Please try again.',
    'pca.sm.showroomNotAvailable': 'Showroom Not Available',
    'pca.sm.showroomDataNotLoaded': 'Showroom data not loaded. Please refresh the page and try again.',
    'pca.sm.publicProfilePreview': 'Public Profile Preview',
    'pca.sm.showingPreview': 'Showing preview of your public showroom profile in new window.',
    'pca.sm.previewBlocked': 'Preview Blocked',
    'pca.sm.popupBlocked': 'Popup blocked. Your showroom is live and accessible to customers.',
    'pca.sm.showroomDataNotAvailable': 'Showroom data not available. Please refresh the page.',
    'pca.sm.editModeEnabled': 'Edit Mode Enabled',
    'pca.sm.editModeDesc': "You can now update your showroom descriptions and details. Don't forget to click '{action}' when done.",
    'pca.sm.replyRequired': 'Reply Required',
    'pca.sm.enterReplyMessage': 'Please enter a reply message.',
    'pca.sm.inquiryNotFound': 'Inquiry Not Found',
    'pca.sm.couldNotFindInquiry': 'Could not find the inquiry to reply to.',
    'pca.sm.replyFnUnavailable': 'Reply function is not available. Please refresh the page.',
    'pca.sm.businessIdRequiredReplies': 'Business ID is required to send replies. Please refresh and try again.',
    'pca.sm.replySent': 'Reply Sent Successfully',
    'pca.sm.replySentDesc': 'Your reply has been sent to {customer}. Status updated to "replied". Dialog will close in 3 seconds.',
    'pca.sm.errorSendingReply': 'Error Sending Reply',
    'pca.sm.failedSendReply': 'Failed to send reply: {error}',
    'pca.sm.responseRequired': 'Response Required',
    'pca.sm.enterResponseMessage': 'Please enter a response message.',
    'pca.sm.reviewNotFound': 'Review Not Found',
    'pca.sm.couldNotFindReview': 'Could not find the review to respond to.',
    'pca.sm.responseFnUnavailable': 'Response function is not available. Please refresh the page.',
    'pca.sm.businessIdRequiredResponses': 'Business ID is required to post responses. Please refresh and try again.',
    'pca.sm.responsePosted': 'Response Posted Successfully',
    'pca.sm.responsePostedDesc': 'Your response to {customer} has been posted. Status updated to "Responded". Dialog will close in 3 seconds.',
    'pca.sm.errorPostingResponse': 'Error Posting Response',
    'pca.sm.failedPostResponse': 'Failed to post response: {error}',
    'pca.sm.addressRequired': 'Address Required',
    'pca.sm.enterAddressLookup': 'Please enter an address to lookup location.',
    'pca.sm.locationFound': 'Location Found',
    'pca.sm.locationVerifiedUpdated': 'Location has been verified and updated.',
    'pca.sm.locationError': 'Location Error',
    'pca.sm.failedFindLocation': 'Failed to find location. Please check the address and try again.',
    'pca.sm.creating': 'Creating...',
    'pca.sm.chat': 'Chat',
    'pca.sm.inAppCalls': 'In-App Calls',
    'pca.sm.noAddressProvided': 'No address provided',
    'pca.sm.contactForPrice': 'Contact for Price',
    'pca.sm.productVideoTitle': 'Product video',
    'pca.sm.unpublish': 'Unpublish',
    'pca.sm.publish': 'Publish',
    'pca.sm.addNewProduct': 'Add New Product',
    'pca.sm.addShowroomItem': 'Add Showroom Item',
    'pca.sm.editShowroomItem': 'Edit Showroom Item',
    'pca.sm.updateItemInfo': 'Update item information',
    'pca.sm.noItemsYet': 'No items yet',
    'pca.sm.addShowroomItemDesc': 'Publish a service or a product to your public showroom.',
    'pca.sm.itemTypeReq': 'Item Type *',
    'pca.sm.itemTypeService': 'Service',
    'pca.sm.itemTypeProduct': 'Product',
    'pca.sm.itemNameReq': 'Item Name *',
    'pca.sm.serviceNameReq': 'Service Name *',
    'pca.sm.itemImagesOptional': 'Images (optional)',
    'pca.sm.uploadToShowroom': 'Upload to Showroom',
    'pca.sm.uploadShowroomImages': 'Upload Showroom Images',
    'pca.sm.addPhotosGallery': 'Add photos to your showroom gallery',
    'pca.sm.dragDropImages': 'Drag and drop images here, or click to browse',
    'pca.sm.selectFiles': 'Select Files',
    'pca.sm.uploadAndClose': 'Upload & Close',
    'pca.sm.viewPublicProfile': 'View Public Profile',
    'pca.sm.customerInquiries': 'Customer Inquiries',
    'pca.sm.performanceTips': 'Performance Tips',
    'pca.sm.addMoreImages': 'Add More Images',
    'pca.sm.images40more': 'Products with 3+ images get 40% more views',
    'pca.sm.uploadImages': 'Upload Images',
    'pca.sm.updateDescriptions': 'Update Descriptions',
    'pca.sm.detailedDescImprove': 'Detailed descriptions improve search visibility',
    'pca.sm.editDescriptions': 'Edit Descriptions',
    'pca.sm.respondToReviews': 'Respond to Reviews',
    'pca.sm.activeEngagement': 'Active engagement builds customer trust',
    'pca.sm.viewReviews': 'View Reviews',
    'pca.sm.createNewShowroom': 'Create New Showroom',
    'pca.sm.quickCreateShowroom': 'Quick-create a showroom for your business',
    'pca.sm.create': 'Create',
    'pca.sm.addProductDesc': 'Add a product or service to your showroom',
    'pca.sm.productNameReq': 'Product Name *',
    'pca.sm.enterProductName': 'Enter product name',
    'pca.sm.descriptionReq': 'Description *',
    'pca.sm.describeProductService': 'Describe your product or service',
    'pca.sm.price': 'Price',
    'pca.sm.categoryReq': 'Category *',
    'pca.sm.selectCategory': 'Select a category…',
    'pca.sm.productImages': 'Product Images',
    'pca.sm.uploading': 'Uploading…',
    'pca.sm.uploadProductImages': 'Upload Product Images',
    'pca.sm.upTo10Images': 'Up to 10 images allowed',
    'pca.sm.recommendedFormat': 'Recommended: 1200x800px, JPG/PNG format',
    'pca.sm.imagesUploadedCount': '{count} image(s) uploaded',
    'pca.sm.productVideo': 'Product Video',
    'pca.sm.optional': '(optional)',
    'pca.sm.uploadProductVideo': 'Upload Product Video',
    'pca.sm.oneVideoPerProduct': 'One video per product',
    'pca.sm.videoFormatMax': 'MP4 or MOV, up to 100MB',
    'pca.sm.videoUploadedLabel': 'Video uploaded',
    'pca.sm.showroomAnalytics': 'Showroom Analytics',
    'pca.sm.detailedMetrics': 'Detailed performance metrics for your showroom',
    'pca.sm.visitors': 'Visitors',
    'pca.sm.inquiries': 'Inquiries',
    'pca.sm.analyticsNotAvailable': 'Detailed showroom analytics are not available yet.',
    'pca.sm.manageInquiries': 'Manage customer questions and requests',
    'pca.sm.replied': 'Replied',
    'pca.sm.from': 'From:',
    'pca.sm.yourReply': 'Your Reply:',
    'pca.sm.repliedOn': 'Replied on:',
    'pca.sm.unknown': 'Unknown',
    'pca.sm.typeReply': 'Type your reply here...',
    'pca.sm.sending': 'Sending...',
    'pca.sm.sendReply': 'Send Reply',
    'pca.sm.reply': 'Reply',
    'pca.sm.replyAgain': 'Reply Again',
    'pca.sm.noInquiriesYet': 'No customer inquiries yet',
    'pca.sm.customerReviews': 'Customer Reviews',
    'pca.sm.respondFeedback': 'Respond to customer feedback and reviews',
    'pca.sm.responded': 'Responded',
    'pca.sm.new': 'New',
    'pca.sm.yourResponse': 'Your Response:',
    'pca.sm.respondedOn': 'Responded on:',
    'pca.sm.thankCustomer': 'Thank the customer and provide your response...',
    'pca.sm.posting': 'Posting...',
    'pca.sm.postResponse': 'Post Response',
    'pca.sm.updateResponse': 'Update Response',
    'pca.sm.respond': 'Respond',
    'pca.sm.noReviewsYet': 'No customer reviews yet',
    'pca.sm.editProduct': 'Edit Product',
    'pca.sm.updateProductInfo': 'Update product information',
    'pca.sm.describeProduct': 'Describe your product...',
    'pca.sm.currentImagesReplace': 'Current images ({count}) — uploading new images replaces these',
    'pca.sm.replaceProductVideo': 'Replace Product Video',
    'pca.sm.newVideoUploaded': 'New video uploaded',
    'pca.sm.currentVideo': 'Current video',
    'pca.sm.removeVideo': 'Remove video',
    'pca.sm.updateProduct': 'Update Product',

    // ---- CreateSurvey ----
    'pca.survey.surveyDetails': 'Survey Details',
    'pca.survey.surveyTitleReq': 'Survey Title *',
    'pca.survey.enterTitle': 'Enter survey title',
    'pca.survey.descriptionReq': 'Description *',
    'pca.survey.describeSurvey': 'Describe what this survey is about',
    'pca.survey.surveyTypeReq': 'Survey Type *',
    'pca.survey.paidSurvey': 'Paid Survey',
    'pca.survey.unpaidSurvey': 'Unpaid Survey',
    'pca.survey.reward': 'Reward',
    'pca.survey.communityPoints': 'Community Points',
    'pca.survey.duration': 'Duration',
    'pca.survey.durationExample': '5-10 minutes',
    'pca.survey.difficulty': 'Difficulty',
    'pca.survey.easy': 'Easy',
    'pca.survey.medium': 'Medium',
    'pca.survey.advanced': 'Advanced',
    'pca.survey.deadlineReq': 'Deadline *',
    'pca.survey.addQuestions': 'Add Questions',
    'pca.survey.questionType': 'Question Type',
    'pca.survey.questionReq': 'Question *',
    'pca.survey.enterYourQuestion': 'Enter your question',
    'pca.survey.options': 'Options',
    'pca.survey.optionN': 'Option {n}',
    'pca.survey.addOption': 'Add Option',
    'pca.survey.requiredQuestion': 'Required Question',
    'pca.survey.addQuestion': 'Add Question',
    'pca.survey.questionsCount': 'Questions ({count})',
    'pca.survey.required': 'Required',
    'pca.survey.creatingSurvey': 'Creating Survey...',
    'pca.survey.preview': 'Preview',
    'pca.survey.details': 'Details',
    'pca.survey.audience': 'Audience',
    'pca.survey.typeLabel': 'Type:',
    'pca.survey.paid': 'Paid',
    'pca.survey.unpaid': 'Unpaid',
    'pca.survey.rewardLabel': 'Reward:',
    'pca.survey.durationLabel': 'Duration:',
    'pca.survey.difficultyLabel': 'Difficulty:',
    'pca.survey.questionsLabel': 'Questions:',
    'pca.survey.fillToPreview': 'Fill in survey details to see preview',
    'pca.survey.targetAll': 'Target: All customers of {business}',
    'pca.survey.yourBusiness': 'your business',
    'pca.survey.deadlineLabel': 'Deadline:',
    'pca.survey.requiredQuestions': '{count} required question(s)',
    'pca.survey.totalQuestions': '{count} total question(s) added',
    'pca.survey.surveyTips': 'Survey Tips',
    'pca.survey.tip1': 'Keep questions clear and concise',
    'pca.survey.tip2': 'Use a mix of question types for engagement',
    'pca.survey.tip3': 'Offer appropriate rewards for survey length',
    'pca.survey.tip4': 'Test your survey before publishing',
    'pca.survey.tip5': 'Set realistic deadlines',
  },
  es: {
    // ---- ShowroomManager ----
    'pca.sm.productPublished': 'Producto publicado',
    'pca.sm.correctionRequested': 'Corrección solicitada',
    'pca.sm.correctionAccepted': 'Corrección aceptada',
    'pca.sm.showroomRequiredHint': 'Crea tu Showroom antes de añadir artículos al Marketplace.',
    'pca.sm.correctionAwaitingReview': 'Corrección enviada — pendiente de revisión',
    'pca.sm.correctionRequestedAt': 'Solicitado',
    'pca.sm.correctionEditHint': 'Edita este anuncio para atender la solicitud y guarda.',
    'pca.sm.correctionSubmittedHint': 'Tu actualización fue enviada. Servisfy la revisará.',
    'pca.sm.productHidden': 'Producto oculto',
    'pca.sm.productNowActive': '{name} ahora está activo.',
    'pca.sm.productNowHidden': '{name} ahora está oculto.',
    'pca.sm.updateFailed': 'Error al actualizar',
    'pca.sm.confirmDeleteProduct': '¿Eliminar "{name}"? Esta acción no se puede deshacer.',
    'pca.sm.productDeleted': 'Producto eliminado',
    'pca.sm.productWasRemoved': '{name} fue eliminado.',
    'pca.sm.deleteFailed': 'Error al eliminar',
    'pca.sm.formError': 'Error del formulario',
    'pca.sm.formNotInit': 'Los datos del formulario no se inicializaron correctamente.',
    'pca.sm.validationError': 'Error de validación',
    'pca.sm.fillRequiredFields': 'Por favor, complete todos los campos obligatorios.',
    'pca.sm.authError': 'Error de autenticación',
    'pca.sm.businessIdRequiredLogin': 'Se requiere el ID de empresa del usuario. Inicie sesión de nuevo.',
    'pca.sm.showroomUpdated': 'Sala de exposición actualizada',
    'pca.sm.showroomUpdatedDesc': '¡Los datos de tu sala de exposición se han actualizado correctamente!',
    'pca.sm.showroomCreated': 'Sala de exposición creada',
    'pca.sm.showroomCreatedDesc': '¡Tu sala de exposición se ha creado correctamente!',
    'pca.sm.failedSaveShowroom': 'No se pudo guardar la sala de exposición. Inténtalo de nuevo.',
    'pca.sm.productNameDescRequired': 'El nombre y la descripción del producto son obligatorios.',
    'pca.sm.categoryRequired': 'Categoría obligatoria',
    'pca.sm.selectCategoryBeforeSaving': 'Selecciona una categoría de producto antes de guardar.',
    'pca.sm.functionNotAvailable': 'Función no disponible',
    'pca.sm.productCreateFnUnavailable': 'La función de creación de productos no está disponible. Actualiza la página.',
    'pca.sm.productAddedTitle': 'Producto añadido correctamente',
    'pca.sm.productAddedDesc': '{name} se ha añadido a tu sala de exposición y ahora es visible en Productos y Servicios.',
    'pca.sm.errorAddingProduct': 'Error al añadir el producto',
    'pca.sm.failedAddProduct': 'No se pudo añadir el producto: {error}',
    'pca.sm.unknownErrorOccurred': 'Se produjo un error desconocido',
    'pca.sm.unknownError': 'Error desconocido',
    'pca.sm.tooManyImages': 'Demasiadas imágenes',
    'pca.sm.selectUpTo10': 'Selecciona un máximo de 10 imágenes en total.',
    'pca.sm.unsupportedFile': 'Archivo no compatible',
    'pca.sm.onlyImageTypes': '{name}: solo se permiten imágenes JPEG, PNG o WebP.',
    'pca.sm.fileTooLarge': 'Archivo demasiado grande',
    'pca.sm.imageMaxSize': '{name}: las imágenes deben ser de 10 MB o menos.',
    'pca.sm.imagesUploaded': 'Imágenes subidas',
    'pca.sm.imagesAdded': '{count} imagen(es) añadida(s).',
    'pca.sm.uploadFailed': 'Error al subir',
    'pca.sm.couldNotUploadImage': 'No se pudo subir la imagen.',
    'pca.sm.onlyVideoTypes': '{name}: solo se permiten videos MP4 o MOV.',
    'pca.sm.videoMaxSize': '{name}: los videos deben ser de 100 MB o menos.',
    'pca.sm.videoUploaded': 'Video subido',
    'pca.sm.productVideoAdded': 'Video del producto añadido.',
    'pca.sm.couldNotUploadVideo': 'No se pudo subir el video.',
    'pca.sm.productUpdateFnUnavailable': 'La función de actualización de productos no está disponible. Actualiza la página.',
    'pca.sm.productUpdated': 'Producto actualizado',
    'pca.sm.productUpdatedDesc': '{name} se ha actualizado correctamente.',
    'pca.sm.errorUpdatingProduct': 'Error al actualizar el producto',
    'pca.sm.failedUpdateProduct': 'No se pudo actualizar el producto: {error}',
    'pca.sm.imagesUploadedTitle': 'Imágenes subidas',
    'pca.sm.imagesUploadedComingSoon': '{count} imagen(es) subida(s). La galería de la sala de exposición estará disponible pronto.',
    'pca.sm.uploadFailedTitle': 'Error al subir',
    'pca.sm.couldNotUploadImages': 'No se pudieron subir las imágenes. Inténtalo de nuevo.',
    'pca.sm.showroomNotAvailable': 'Sala de exposición no disponible',
    'pca.sm.showroomDataNotLoaded': 'No se cargaron los datos de la sala de exposición. Actualiza la página e inténtalo de nuevo.',
    'pca.sm.publicProfilePreview': 'Vista previa del perfil público',
    'pca.sm.showingPreview': 'Mostrando la vista previa de tu perfil público de la sala de exposición en una ventana nueva.',
    'pca.sm.previewBlocked': 'Vista previa bloqueada',
    'pca.sm.popupBlocked': 'Ventana emergente bloqueada. Tu sala de exposición está activa y accesible para los clientes.',
    'pca.sm.showroomDataNotAvailable': 'Datos de la sala de exposición no disponibles. Actualiza la página.',
    'pca.sm.editModeEnabled': 'Modo de edición activado',
    'pca.sm.editModeDesc': "Ahora puedes actualizar las descripciones y los detalles de tu sala de exposición. No olvides hacer clic en '{action}' cuando termines.",
    'pca.sm.replyRequired': 'Respuesta obligatoria',
    'pca.sm.enterReplyMessage': 'Escribe un mensaje de respuesta.',
    'pca.sm.inquiryNotFound': 'Consulta no encontrada',
    'pca.sm.couldNotFindInquiry': 'No se pudo encontrar la consulta para responder.',
    'pca.sm.replyFnUnavailable': 'La función de respuesta no está disponible. Actualiza la página.',
    'pca.sm.businessIdRequiredReplies': 'Se requiere el ID de empresa para enviar respuestas. Actualiza e inténtalo de nuevo.',
    'pca.sm.replySent': 'Respuesta enviada correctamente',
    'pca.sm.replySentDesc': 'Tu respuesta se ha enviado a {customer}. El estado se actualizó a "respondido". El cuadro de diálogo se cerrará en 3 segundos.',
    'pca.sm.errorSendingReply': 'Error al enviar la respuesta',
    'pca.sm.failedSendReply': 'No se pudo enviar la respuesta: {error}',
    'pca.sm.responseRequired': 'Respuesta obligatoria',
    'pca.sm.enterResponseMessage': 'Escribe un mensaje de respuesta.',
    'pca.sm.reviewNotFound': 'Reseña no encontrada',
    'pca.sm.couldNotFindReview': 'No se pudo encontrar la reseña para responder.',
    'pca.sm.responseFnUnavailable': 'La función de respuesta no está disponible. Actualiza la página.',
    'pca.sm.businessIdRequiredResponses': 'Se requiere el ID de empresa para publicar respuestas. Actualiza e inténtalo de nuevo.',
    'pca.sm.responsePosted': 'Respuesta publicada correctamente',
    'pca.sm.responsePostedDesc': 'Tu respuesta a {customer} se ha publicado. El estado se actualizó a "Respondido". El cuadro de diálogo se cerrará en 3 segundos.',
    'pca.sm.errorPostingResponse': 'Error al publicar la respuesta',
    'pca.sm.failedPostResponse': 'No se pudo publicar la respuesta: {error}',
    'pca.sm.addressRequired': 'Dirección obligatoria',
    'pca.sm.enterAddressLookup': 'Introduce una dirección para buscar la ubicación.',
    'pca.sm.locationFound': 'Ubicación encontrada',
    'pca.sm.locationVerifiedUpdated': 'La ubicación se ha verificado y actualizado.',
    'pca.sm.locationError': 'Error de ubicación',
    'pca.sm.failedFindLocation': 'No se pudo encontrar la ubicación. Verifica la dirección e inténtalo de nuevo.',
    'pca.sm.creating': 'Creando...',
    'pca.sm.chat': 'Chat',
    'pca.sm.inAppCalls': 'Llamadas en la app',
    'pca.sm.noAddressProvided': 'No se proporcionó dirección',
    'pca.sm.contactForPrice': 'Consultar precio',
    'pca.sm.productVideoTitle': 'Video del producto',
    'pca.sm.unpublish': 'Despublicar',
    'pca.sm.publish': 'Publicar',
    'pca.sm.addNewProduct': 'Añadir nuevo producto',
    'pca.sm.addShowroomItem': 'Añadir artículo al showroom',
    'pca.sm.editShowroomItem': 'Editar artículo del showroom',
    'pca.sm.updateItemInfo': 'Actualiza la información del artículo',
    'pca.sm.noItemsYet': 'Aún no hay artículos',
    'pca.sm.addShowroomItemDesc': 'Publica un servicio o un producto en tu showroom público.',
    'pca.sm.itemTypeReq': 'Tipo de artículo *',
    'pca.sm.itemTypeService': 'Servicio',
    'pca.sm.itemTypeProduct': 'Producto',
    'pca.sm.itemNameReq': 'Nombre del artículo *',
    'pca.sm.serviceNameReq': 'Nombre del servicio *',
    'pca.sm.itemImagesOptional': 'Imágenes (opcional)',
    'pca.sm.uploadToShowroom': 'Subir a la sala de exposición',
    'pca.sm.uploadShowroomImages': 'Subir imágenes de la sala de exposición',
    'pca.sm.addPhotosGallery': 'Añade fotos a la galería de tu sala de exposición',
    'pca.sm.dragDropImages': 'Arrastra y suelta imágenes aquí, o haz clic para buscar',
    'pca.sm.selectFiles': 'Seleccionar archivos',
    'pca.sm.uploadAndClose': 'Subir y cerrar',
    'pca.sm.viewPublicProfile': 'Ver perfil público',
    'pca.sm.customerInquiries': 'Consultas de clientes',
    'pca.sm.performanceTips': 'Consejos de rendimiento',
    'pca.sm.addMoreImages': 'Añadir más imágenes',
    'pca.sm.images40more': 'Los productos con 3 o más imágenes obtienen un 40 % más de vistas',
    'pca.sm.uploadImages': 'Subir imágenes',
    'pca.sm.updateDescriptions': 'Actualizar descripciones',
    'pca.sm.detailedDescImprove': 'Las descripciones detalladas mejoran la visibilidad en las búsquedas',
    'pca.sm.editDescriptions': 'Editar descripciones',
    'pca.sm.respondToReviews': 'Responder a las reseñas',
    'pca.sm.activeEngagement': 'La participación activa genera confianza en los clientes',
    'pca.sm.viewReviews': 'Ver reseñas',
    'pca.sm.createNewShowroom': 'Crear nueva sala de exposición',
    'pca.sm.quickCreateShowroom': 'Crea rápidamente una sala de exposición para tu empresa',
    'pca.sm.create': 'Crear',
    'pca.sm.addProductDesc': 'Añade un producto o servicio a tu sala de exposición',
    'pca.sm.productNameReq': 'Nombre del producto *',
    'pca.sm.enterProductName': 'Introduce el nombre del producto',
    'pca.sm.descriptionReq': 'Descripción *',
    'pca.sm.describeProductService': 'Describe tu producto o servicio',
    'pca.sm.price': 'Precio',
    'pca.sm.categoryReq': 'Categoría *',
    'pca.sm.selectCategory': 'Selecciona una categoría…',
    'pca.sm.productImages': 'Imágenes del producto',
    'pca.sm.uploading': 'Subiendo…',
    'pca.sm.uploadProductImages': 'Subir imágenes del producto',
    'pca.sm.upTo10Images': 'Se permiten hasta 10 imágenes',
    'pca.sm.recommendedFormat': 'Recomendado: 1200x800px, formato JPG/PNG',
    'pca.sm.imagesUploadedCount': '{count} imagen(es) subida(s)',
    'pca.sm.productVideo': 'Video del producto',
    'pca.sm.optional': '(opcional)',
    'pca.sm.uploadProductVideo': 'Subir video del producto',
    'pca.sm.oneVideoPerProduct': 'Un video por producto',
    'pca.sm.videoFormatMax': 'MP4 o MOV, hasta 100 MB',
    'pca.sm.videoUploadedLabel': 'Video subido',
    'pca.sm.showroomAnalytics': 'Analíticas de la sala de exposición',
    'pca.sm.detailedMetrics': 'Métricas de rendimiento detalladas de tu sala de exposición',
    'pca.sm.visitors': 'Visitantes',
    'pca.sm.inquiries': 'Consultas',
    'pca.sm.analyticsNotAvailable': 'Las analíticas detalladas de la sala de exposición aún no están disponibles.',
    'pca.sm.manageInquiries': 'Gestiona las preguntas y solicitudes de los clientes',
    'pca.sm.replied': 'Respondido',
    'pca.sm.from': 'De:',
    'pca.sm.yourReply': 'Tu respuesta:',
    'pca.sm.repliedOn': 'Respondido el:',
    'pca.sm.unknown': 'Desconocido',
    'pca.sm.typeReply': 'Escribe tu respuesta aquí...',
    'pca.sm.sending': 'Enviando...',
    'pca.sm.sendReply': 'Enviar respuesta',
    'pca.sm.reply': 'Responder',
    'pca.sm.replyAgain': 'Responder de nuevo',
    'pca.sm.noInquiriesYet': 'Aún no hay consultas de clientes',
    'pca.sm.customerReviews': 'Reseñas de clientes',
    'pca.sm.respondFeedback': 'Responde a los comentarios y reseñas de los clientes',
    'pca.sm.responded': 'Respondido',
    'pca.sm.new': 'Nuevo',
    'pca.sm.yourResponse': 'Tu respuesta:',
    'pca.sm.respondedOn': 'Respondido el:',
    'pca.sm.thankCustomer': 'Agradece al cliente y proporciona tu respuesta...',
    'pca.sm.posting': 'Publicando...',
    'pca.sm.postResponse': 'Publicar respuesta',
    'pca.sm.updateResponse': 'Actualizar respuesta',
    'pca.sm.respond': 'Responder',
    'pca.sm.noReviewsYet': 'Aún no hay reseñas de clientes',
    'pca.sm.editProduct': 'Editar producto',
    'pca.sm.updateProductInfo': 'Actualiza la información del producto',
    'pca.sm.describeProduct': 'Describe tu producto...',
    'pca.sm.currentImagesReplace': 'Imágenes actuales ({count}): subir nuevas imágenes las reemplaza',
    'pca.sm.replaceProductVideo': 'Reemplazar video del producto',
    'pca.sm.newVideoUploaded': 'Nuevo video subido',
    'pca.sm.currentVideo': 'Video actual',
    'pca.sm.removeVideo': 'Eliminar video',
    'pca.sm.updateProduct': 'Actualizar producto',

    // ---- CreateSurvey ----
    'pca.survey.surveyDetails': 'Detalles de la encuesta',
    'pca.survey.surveyTitleReq': 'Título de la encuesta *',
    'pca.survey.enterTitle': 'Introduce el título de la encuesta',
    'pca.survey.descriptionReq': 'Descripción *',
    'pca.survey.describeSurvey': 'Describe de qué trata esta encuesta',
    'pca.survey.surveyTypeReq': 'Tipo de encuesta *',
    'pca.survey.paidSurvey': 'Encuesta remunerada',
    'pca.survey.unpaidSurvey': 'Encuesta no remunerada',
    'pca.survey.reward': 'Recompensa',
    'pca.survey.communityPoints': 'Puntos de comunidad',
    'pca.survey.duration': 'Duración',
    'pca.survey.durationExample': '5-10 minutos',
    'pca.survey.difficulty': 'Dificultad',
    'pca.survey.easy': 'Fácil',
    'pca.survey.medium': 'Media',
    'pca.survey.advanced': 'Avanzada',
    'pca.survey.deadlineReq': 'Fecha límite *',
    'pca.survey.addQuestions': 'Añadir preguntas',
    'pca.survey.questionType': 'Tipo de pregunta',
    'pca.survey.questionReq': 'Pregunta *',
    'pca.survey.enterYourQuestion': 'Introduce tu pregunta',
    'pca.survey.options': 'Opciones',
    'pca.survey.optionN': 'Opción {n}',
    'pca.survey.addOption': 'Añadir opción',
    'pca.survey.requiredQuestion': 'Pregunta obligatoria',
    'pca.survey.addQuestion': 'Añadir pregunta',
    'pca.survey.questionsCount': 'Preguntas ({count})',
    'pca.survey.required': 'Obligatoria',
    'pca.survey.creatingSurvey': 'Creando encuesta...',
    'pca.survey.preview': 'Vista previa',
    'pca.survey.details': 'Detalles',
    'pca.survey.audience': 'Audiencia',
    'pca.survey.typeLabel': 'Tipo:',
    'pca.survey.paid': 'Remunerada',
    'pca.survey.unpaid': 'No remunerada',
    'pca.survey.rewardLabel': 'Recompensa:',
    'pca.survey.durationLabel': 'Duración:',
    'pca.survey.difficultyLabel': 'Dificultad:',
    'pca.survey.questionsLabel': 'Preguntas:',
    'pca.survey.fillToPreview': 'Completa los detalles de la encuesta para ver la vista previa',
    'pca.survey.targetAll': 'Objetivo: Todos los clientes de {business}',
    'pca.survey.yourBusiness': 'tu empresa',
    'pca.survey.deadlineLabel': 'Fecha límite:',
    'pca.survey.requiredQuestions': '{count} pregunta(s) obligatoria(s)',
    'pca.survey.totalQuestions': '{count} pregunta(s) en total añadida(s)',
    'pca.survey.surveyTips': 'Consejos para encuestas',
    'pca.survey.tip1': 'Mantén las preguntas claras y concisas',
    'pca.survey.tip2': 'Usa una combinación de tipos de preguntas para mayor participación',
    'pca.survey.tip3': 'Ofrece recompensas adecuadas según la duración de la encuesta',
    'pca.survey.tip4': 'Prueba tu encuesta antes de publicarla',
    'pca.survey.tip5': 'Establece fechas límite realistas',
  },
  fr: {
    // ---- ShowroomManager ----
    'pca.sm.productPublished': 'Produit publié',
    'pca.sm.correctionRequested': 'Correction demandée',
    'pca.sm.correctionAccepted': 'Correction acceptée',
    'pca.sm.showroomRequiredHint': 'Créez votre Showroom avant d’ajouter des articles au Marketplace.',
    'pca.sm.correctionAwaitingReview': 'Correction envoyée — en attente d’examen',
    'pca.sm.correctionRequestedAt': 'Demandé le',
    'pca.sm.correctionEditHint': 'Modifiez cette annonce pour répondre à la demande, puis enregistrez.',
    'pca.sm.correctionSubmittedHint': 'Votre mise à jour a été envoyée. Servisfy va l’examiner.',
    'pca.sm.productHidden': 'Produit masqué',
    'pca.sm.productNowActive': '{name} est maintenant actif.',
    'pca.sm.productNowHidden': '{name} est maintenant masqué.',
    'pca.sm.updateFailed': 'Échec de la mise à jour',
    'pca.sm.confirmDeleteProduct': 'Supprimer « {name} » ? Cette action est irréversible.',
    'pca.sm.productDeleted': 'Produit supprimé',
    'pca.sm.productWasRemoved': '{name} a été supprimé.',
    'pca.sm.deleteFailed': 'Échec de la suppression',
    'pca.sm.formError': 'Erreur de formulaire',
    'pca.sm.formNotInit': 'Les données du formulaire ne sont pas correctement initialisées.',
    'pca.sm.validationError': 'Erreur de validation',
    'pca.sm.fillRequiredFields': 'Veuillez remplir tous les champs obligatoires.',
    'pca.sm.authError': "Erreur d'authentification",
    'pca.sm.businessIdRequiredLogin': "L'identifiant d'entreprise de l'utilisateur est requis. Veuillez vous reconnecter.",
    'pca.sm.showroomUpdated': 'Vitrine mise à jour',
    'pca.sm.showroomUpdatedDesc': 'Les informations de votre vitrine ont été mises à jour avec succès !',
    'pca.sm.showroomCreated': 'Vitrine créée',
    'pca.sm.showroomCreatedDesc': 'Votre vitrine a été créée avec succès !',
    'pca.sm.failedSaveShowroom': "Échec de l'enregistrement de la vitrine. Veuillez réessayer.",
    'pca.sm.productNameDescRequired': 'Le nom et la description du produit sont obligatoires.',
    'pca.sm.categoryRequired': 'Catégorie requise',
    'pca.sm.selectCategoryBeforeSaving': "Veuillez sélectionner une catégorie de produit avant d'enregistrer.",
    'pca.sm.functionNotAvailable': 'Fonction non disponible',
    'pca.sm.productCreateFnUnavailable': "La fonction de création de produit n'est pas disponible. Veuillez actualiser la page.",
    'pca.sm.productAddedTitle': 'Produit ajouté avec succès',
    'pca.sm.productAddedDesc': '{name} a été ajouté à votre vitrine et est désormais visible dans Produits et Services.',
    'pca.sm.errorAddingProduct': "Erreur lors de l'ajout du produit",
    'pca.sm.failedAddProduct': "Échec de l'ajout du produit : {error}",
    'pca.sm.unknownErrorOccurred': "Une erreur inconnue s'est produite",
    'pca.sm.unknownError': 'Erreur inconnue',
    'pca.sm.tooManyImages': "Trop d'images",
    'pca.sm.selectUpTo10': "Veuillez sélectionner au maximum 10 images au total.",
    'pca.sm.unsupportedFile': 'Fichier non pris en charge',
    'pca.sm.onlyImageTypes': '{name} : seules les images JPEG, PNG ou WebP sont autorisées.',
    'pca.sm.fileTooLarge': 'Fichier trop volumineux',
    'pca.sm.imageMaxSize': '{name} : les images doivent faire 10 Mo ou moins.',
    'pca.sm.imagesUploaded': 'Images téléchargées',
    'pca.sm.imagesAdded': '{count} image(s) ajoutée(s).',
    'pca.sm.uploadFailed': 'Échec du téléchargement',
    'pca.sm.couldNotUploadImage': "Impossible de télécharger l'image.",
    'pca.sm.onlyVideoTypes': '{name} : seules les vidéos MP4 ou MOV sont autorisées.',
    'pca.sm.videoMaxSize': '{name} : les vidéos doivent faire 100 Mo ou moins.',
    'pca.sm.videoUploaded': 'Vidéo téléchargée',
    'pca.sm.productVideoAdded': 'Vidéo du produit ajoutée.',
    'pca.sm.couldNotUploadVideo': 'Impossible de télécharger la vidéo.',
    'pca.sm.productUpdateFnUnavailable': "La fonction de mise à jour du produit n'est pas disponible. Veuillez actualiser la page.",
    'pca.sm.productUpdated': 'Produit mis à jour',
    'pca.sm.productUpdatedDesc': '{name} a été mis à jour avec succès.',
    'pca.sm.errorUpdatingProduct': 'Erreur lors de la mise à jour du produit',
    'pca.sm.failedUpdateProduct': 'Échec de la mise à jour du produit : {error}',
    'pca.sm.imagesUploadedTitle': 'Images téléchargées',
    'pca.sm.imagesUploadedComingSoon': '{count} image(s) téléchargée(s). La galerie de la vitrine arrive bientôt.',
    'pca.sm.uploadFailedTitle': 'Échec du téléchargement',
    'pca.sm.couldNotUploadImages': 'Impossible de télécharger les images. Veuillez réessayer.',
    'pca.sm.showroomNotAvailable': 'Vitrine non disponible',
    'pca.sm.showroomDataNotLoaded': 'Les données de la vitrine ne sont pas chargées. Veuillez actualiser la page et réessayer.',
    'pca.sm.publicProfilePreview': 'Aperçu du profil public',
    'pca.sm.showingPreview': "Aperçu de votre profil public de vitrine affiché dans une nouvelle fenêtre.",
    'pca.sm.previewBlocked': 'Aperçu bloqué',
    'pca.sm.popupBlocked': 'Fenêtre contextuelle bloquée. Votre vitrine est en ligne et accessible aux clients.',
    'pca.sm.showroomDataNotAvailable': 'Données de la vitrine non disponibles. Veuillez actualiser la page.',
    'pca.sm.editModeEnabled': "Mode d'édition activé",
    'pca.sm.editModeDesc': "Vous pouvez maintenant mettre à jour les descriptions et les détails de votre vitrine. N'oubliez pas de cliquer sur « {action} » une fois terminé.",
    'pca.sm.replyRequired': 'Réponse requise',
    'pca.sm.enterReplyMessage': 'Veuillez saisir un message de réponse.',
    'pca.sm.inquiryNotFound': 'Demande introuvable',
    'pca.sm.couldNotFindInquiry': 'Impossible de trouver la demande à laquelle répondre.',
    'pca.sm.replyFnUnavailable': "La fonction de réponse n'est pas disponible. Veuillez actualiser la page.",
    'pca.sm.businessIdRequiredReplies': "L'identifiant d'entreprise est requis pour envoyer des réponses. Veuillez actualiser et réessayer.",
    'pca.sm.replySent': 'Réponse envoyée avec succès',
    'pca.sm.replySentDesc': 'Votre réponse a été envoyée à {customer}. Statut mis à jour sur « répondu ». La boîte de dialogue se fermera dans 3 secondes.',
    'pca.sm.errorSendingReply': "Erreur lors de l'envoi de la réponse",
    'pca.sm.failedSendReply': "Échec de l'envoi de la réponse : {error}",
    'pca.sm.responseRequired': 'Réponse requise',
    'pca.sm.enterResponseMessage': 'Veuillez saisir un message de réponse.',
    'pca.sm.reviewNotFound': 'Avis introuvable',
    'pca.sm.couldNotFindReview': "Impossible de trouver l'avis auquel répondre.",
    'pca.sm.responseFnUnavailable': "La fonction de réponse n'est pas disponible. Veuillez actualiser la page.",
    'pca.sm.businessIdRequiredResponses': "L'identifiant d'entreprise est requis pour publier des réponses. Veuillez actualiser et réessayer.",
    'pca.sm.responsePosted': 'Réponse publiée avec succès',
    'pca.sm.responsePostedDesc': 'Votre réponse à {customer} a été publiée. Statut mis à jour sur « Répondu ». La boîte de dialogue se fermera dans 3 secondes.',
    'pca.sm.errorPostingResponse': 'Erreur lors de la publication de la réponse',
    'pca.sm.failedPostResponse': 'Échec de la publication de la réponse : {error}',
    'pca.sm.addressRequired': 'Adresse requise',
    'pca.sm.enterAddressLookup': 'Veuillez saisir une adresse pour rechercher la localisation.',
    'pca.sm.locationFound': 'Localisation trouvée',
    'pca.sm.locationVerifiedUpdated': 'La localisation a été vérifiée et mise à jour.',
    'pca.sm.locationError': 'Erreur de localisation',
    'pca.sm.failedFindLocation': "Impossible de trouver la localisation. Veuillez vérifier l'adresse et réessayer.",
    'pca.sm.creating': 'Création...',
    'pca.sm.chat': 'Chat',
    'pca.sm.inAppCalls': "Appels dans l'app",
    'pca.sm.noAddressProvided': 'Aucune adresse fournie',
    'pca.sm.contactForPrice': 'Prix sur demande',
    'pca.sm.productVideoTitle': 'Vidéo du produit',
    'pca.sm.unpublish': 'Dépublier',
    'pca.sm.publish': 'Publier',
    'pca.sm.addNewProduct': 'Ajouter un nouveau produit',
    'pca.sm.addShowroomItem': 'Ajouter un élément à la vitrine',
    'pca.sm.editShowroomItem': 'Modifier l\'élément de la vitrine',
    'pca.sm.updateItemInfo': 'Mettre à jour les informations de l\'élément',
    'pca.sm.noItemsYet': 'Aucun élément pour le moment',
    'pca.sm.addShowroomItemDesc': 'Publiez un service ou un produit dans votre vitrine publique.',
    'pca.sm.itemTypeReq': 'Type d\'élément *',
    'pca.sm.itemTypeService': 'Service',
    'pca.sm.itemTypeProduct': 'Produit',
    'pca.sm.itemNameReq': 'Nom de l\'élément *',
    'pca.sm.serviceNameReq': 'Nom du service *',
    'pca.sm.itemImagesOptional': 'Images (facultatif)',
    'pca.sm.uploadToShowroom': 'Téléverser dans la vitrine',
    'pca.sm.uploadShowroomImages': 'Téléverser des images de la vitrine',
    'pca.sm.addPhotosGallery': 'Ajoutez des photos à la galerie de votre vitrine',
    'pca.sm.dragDropImages': 'Glissez-déposez les images ici, ou cliquez pour parcourir',
    'pca.sm.selectFiles': 'Sélectionner des fichiers',
    'pca.sm.uploadAndClose': 'Téléverser et fermer',
    'pca.sm.viewPublicProfile': 'Voir le profil public',
    'pca.sm.customerInquiries': 'Demandes des clients',
    'pca.sm.performanceTips': 'Conseils de performance',
    'pca.sm.addMoreImages': "Ajouter plus d'images",
    'pca.sm.images40more': "Les produits avec 3 images ou plus obtiennent 40 % de vues en plus",
    'pca.sm.uploadImages': 'Téléverser des images',
    'pca.sm.updateDescriptions': 'Mettre à jour les descriptions',
    'pca.sm.detailedDescImprove': 'Des descriptions détaillées améliorent la visibilité dans les recherches',
    'pca.sm.editDescriptions': 'Modifier les descriptions',
    'pca.sm.respondToReviews': 'Répondre aux avis',
    'pca.sm.activeEngagement': "Un engagement actif renforce la confiance des clients",
    'pca.sm.viewReviews': 'Voir les avis',
    'pca.sm.createNewShowroom': 'Créer une nouvelle vitrine',
    'pca.sm.quickCreateShowroom': 'Créez rapidement une vitrine pour votre entreprise',
    'pca.sm.create': 'Créer',
    'pca.sm.addProductDesc': 'Ajoutez un produit ou un service à votre vitrine',
    'pca.sm.productNameReq': 'Nom du produit *',
    'pca.sm.enterProductName': 'Saisissez le nom du produit',
    'pca.sm.descriptionReq': 'Description *',
    'pca.sm.describeProductService': 'Décrivez votre produit ou service',
    'pca.sm.price': 'Prix',
    'pca.sm.categoryReq': 'Catégorie *',
    'pca.sm.selectCategory': 'Sélectionnez une catégorie…',
    'pca.sm.productImages': 'Images du produit',
    'pca.sm.uploading': 'Téléversement…',
    'pca.sm.uploadProductImages': 'Téléverser des images du produit',
    'pca.sm.upTo10Images': "Jusqu'à 10 images autorisées",
    'pca.sm.recommendedFormat': 'Recommandé : 1200x800px, format JPG/PNG',
    'pca.sm.imagesUploadedCount': '{count} image(s) téléversée(s)',
    'pca.sm.productVideo': 'Vidéo du produit',
    'pca.sm.optional': '(facultatif)',
    'pca.sm.uploadProductVideo': 'Téléverser une vidéo du produit',
    'pca.sm.oneVideoPerProduct': 'Une vidéo par produit',
    'pca.sm.videoFormatMax': "MP4 ou MOV, jusqu'à 100 Mo",
    'pca.sm.videoUploadedLabel': 'Vidéo téléversée',
    'pca.sm.showroomAnalytics': 'Analyses de la vitrine',
    'pca.sm.detailedMetrics': 'Indicateurs de performance détaillés de votre vitrine',
    'pca.sm.visitors': 'Visiteurs',
    'pca.sm.inquiries': 'Demandes',
    'pca.sm.analyticsNotAvailable': 'Les analyses détaillées de la vitrine ne sont pas encore disponibles.',
    'pca.sm.manageInquiries': 'Gérez les questions et les demandes des clients',
    'pca.sm.replied': 'Répondu',
    'pca.sm.from': 'De :',
    'pca.sm.yourReply': 'Votre réponse :',
    'pca.sm.repliedOn': 'Répondu le :',
    'pca.sm.unknown': 'Inconnu',
    'pca.sm.typeReply': 'Saisissez votre réponse ici...',
    'pca.sm.sending': 'Envoi...',
    'pca.sm.sendReply': 'Envoyer la réponse',
    'pca.sm.reply': 'Répondre',
    'pca.sm.replyAgain': 'Répondre à nouveau',
    'pca.sm.noInquiriesYet': 'Aucune demande de client pour le moment',
    'pca.sm.customerReviews': 'Avis des clients',
    'pca.sm.respondFeedback': 'Répondez aux commentaires et aux avis des clients',
    'pca.sm.responded': 'Répondu',
    'pca.sm.new': 'Nouveau',
    'pca.sm.yourResponse': 'Votre réponse :',
    'pca.sm.respondedOn': 'Répondu le :',
    'pca.sm.thankCustomer': 'Remerciez le client et fournissez votre réponse...',
    'pca.sm.posting': 'Publication...',
    'pca.sm.postResponse': 'Publier la réponse',
    'pca.sm.updateResponse': 'Mettre à jour la réponse',
    'pca.sm.respond': 'Répondre',
    'pca.sm.noReviewsYet': "Aucun avis de client pour le moment",
    'pca.sm.editProduct': 'Modifier le produit',
    'pca.sm.updateProductInfo': 'Mettez à jour les informations du produit',
    'pca.sm.describeProduct': 'Décrivez votre produit...',
    'pca.sm.currentImagesReplace': 'Images actuelles ({count}) — téléverser de nouvelles images les remplace',
    'pca.sm.replaceProductVideo': 'Remplacer la vidéo du produit',
    'pca.sm.newVideoUploaded': 'Nouvelle vidéo téléversée',
    'pca.sm.currentVideo': 'Vidéo actuelle',
    'pca.sm.removeVideo': 'Supprimer la vidéo',
    'pca.sm.updateProduct': 'Mettre à jour le produit',

    // ---- CreateSurvey ----
    'pca.survey.surveyDetails': "Détails du sondage",
    'pca.survey.surveyTitleReq': 'Titre du sondage *',
    'pca.survey.enterTitle': 'Saisissez le titre du sondage',
    'pca.survey.descriptionReq': 'Description *',
    'pca.survey.describeSurvey': 'Décrivez le sujet de ce sondage',
    'pca.survey.surveyTypeReq': 'Type de sondage *',
    'pca.survey.paidSurvey': 'Sondage rémunéré',
    'pca.survey.unpaidSurvey': 'Sondage non rémunéré',
    'pca.survey.reward': 'Récompense',
    'pca.survey.communityPoints': 'Points communautaires',
    'pca.survey.duration': 'Durée',
    'pca.survey.durationExample': '5-10 minutes',
    'pca.survey.difficulty': 'Difficulté',
    'pca.survey.easy': 'Facile',
    'pca.survey.medium': 'Moyenne',
    'pca.survey.advanced': 'Avancée',
    'pca.survey.deadlineReq': 'Date limite *',
    'pca.survey.addQuestions': 'Ajouter des questions',
    'pca.survey.questionType': 'Type de question',
    'pca.survey.questionReq': 'Question *',
    'pca.survey.enterYourQuestion': 'Saisissez votre question',
    'pca.survey.options': 'Options',
    'pca.survey.optionN': 'Option {n}',
    'pca.survey.addOption': 'Ajouter une option',
    'pca.survey.requiredQuestion': 'Question obligatoire',
    'pca.survey.addQuestion': 'Ajouter une question',
    'pca.survey.questionsCount': 'Questions ({count})',
    'pca.survey.required': 'Obligatoire',
    'pca.survey.creatingSurvey': 'Création du sondage...',
    'pca.survey.preview': 'Aperçu',
    'pca.survey.details': 'Détails',
    'pca.survey.audience': 'Audience',
    'pca.survey.typeLabel': 'Type :',
    'pca.survey.paid': 'Rémunéré',
    'pca.survey.unpaid': 'Non rémunéré',
    'pca.survey.rewardLabel': 'Récompense :',
    'pca.survey.durationLabel': 'Durée :',
    'pca.survey.difficultyLabel': 'Difficulté :',
    'pca.survey.questionsLabel': 'Questions :',
    'pca.survey.fillToPreview': "Remplissez les détails du sondage pour voir l'aperçu",
    'pca.survey.targetAll': 'Cible : Tous les clients de {business}',
    'pca.survey.yourBusiness': 'votre entreprise',
    'pca.survey.deadlineLabel': 'Date limite :',
    'pca.survey.requiredQuestions': '{count} question(s) obligatoire(s)',
    'pca.survey.totalQuestions': '{count} question(s) ajoutée(s) au total',
    'pca.survey.surveyTips': 'Conseils pour les sondages',
    'pca.survey.tip1': 'Gardez des questions claires et concises',
    'pca.survey.tip2': "Utilisez un mélange de types de questions pour favoriser l'engagement",
    'pca.survey.tip3': 'Offrez des récompenses adaptées à la durée du sondage',
    'pca.survey.tip4': 'Testez votre sondage avant de le publier',
    'pca.survey.tip5': 'Fixez des dates limites réalistes',
  },
  pt: {
    // ---- ShowroomManager ----
    'pca.sm.productPublished': 'Produto publicado',
    'pca.sm.correctionRequested': 'Correção solicitada',
    'pca.sm.correctionAccepted': 'Correção aceita',
    'pca.sm.showroomRequiredHint': 'Crie o seu Showroom antes de adicionar itens ao Marketplace.',
    'pca.sm.correctionAwaitingReview': 'Correção enviada — aguardando revisão',
    'pca.sm.correctionRequestedAt': 'Solicitado em',
    'pca.sm.correctionEditHint': 'Edite este anúncio para atender à solicitação e salve.',
    'pca.sm.correctionSubmittedHint': 'Sua atualização foi enviada. A Servisfy irá revisá-la.',
    'pca.sm.productHidden': 'Produto oculto',
    'pca.sm.productNowActive': '{name} agora está ativo.',
    'pca.sm.productNowHidden': '{name} agora está oculto.',
    'pca.sm.updateFailed': 'Falha na atualização',
    'pca.sm.confirmDeleteProduct': 'Excluir "{name}"? Esta ação não pode ser desfeita.',
    'pca.sm.productDeleted': 'Produto excluído',
    'pca.sm.productWasRemoved': '{name} foi removido.',
    'pca.sm.deleteFailed': 'Falha na exclusão',
    'pca.sm.formError': 'Erro no formulário',
    'pca.sm.formNotInit': 'Os dados do formulário não foram inicializados corretamente.',
    'pca.sm.validationError': 'Erro de validação',
    'pca.sm.fillRequiredFields': 'Preencha todos os campos obrigatórios.',
    'pca.sm.authError': 'Erro de autenticação',
    'pca.sm.businessIdRequiredLogin': 'O ID da empresa do usuário é obrigatório. Faça login novamente.',
    'pca.sm.showroomUpdated': 'Showroom atualizado',
    'pca.sm.showroomUpdatedDesc': 'Os dados do seu showroom foram atualizados com sucesso!',
    'pca.sm.showroomCreated': 'Showroom criado',
    'pca.sm.showroomCreatedDesc': 'Seu showroom foi criado com sucesso!',
    'pca.sm.failedSaveShowroom': 'Falha ao salvar o showroom. Tente novamente.',
    'pca.sm.productNameDescRequired': 'O nome e a descrição do produto são obrigatórios.',
    'pca.sm.categoryRequired': 'Categoria obrigatória',
    'pca.sm.selectCategoryBeforeSaving': 'Selecione uma categoria de produto antes de salvar.',
    'pca.sm.functionNotAvailable': 'Função não disponível',
    'pca.sm.productCreateFnUnavailable': 'A função de criação de produtos não está disponível. Atualize a página.',
    'pca.sm.productAddedTitle': 'Produto adicionado com sucesso',
    'pca.sm.productAddedDesc': '{name} foi adicionado ao seu showroom e agora está visível em Produtos e Serviços.',
    'pca.sm.errorAddingProduct': 'Erro ao adicionar o produto',
    'pca.sm.failedAddProduct': 'Falha ao adicionar o produto: {error}',
    'pca.sm.unknownErrorOccurred': 'Ocorreu um erro desconhecido',
    'pca.sm.unknownError': 'Erro desconhecido',
    'pca.sm.tooManyImages': 'Imagens em excesso',
    'pca.sm.selectUpTo10': 'Selecione no máximo 10 imagens no total.',
    'pca.sm.unsupportedFile': 'Arquivo não compatível',
    'pca.sm.onlyImageTypes': '{name}: apenas imagens JPEG, PNG ou WebP são permitidas.',
    'pca.sm.fileTooLarge': 'Arquivo muito grande',
    'pca.sm.imageMaxSize': '{name}: as imagens devem ter 10 MB ou menos.',
    'pca.sm.imagesUploaded': 'Imagens enviadas',
    'pca.sm.imagesAdded': '{count} imagem(ns) adicionada(s).',
    'pca.sm.uploadFailed': 'Falha no envio',
    'pca.sm.couldNotUploadImage': 'Não foi possível enviar a imagem.',
    'pca.sm.onlyVideoTypes': '{name}: apenas vídeos MP4 ou MOV são permitidos.',
    'pca.sm.videoMaxSize': '{name}: os vídeos devem ter 100 MB ou menos.',
    'pca.sm.videoUploaded': 'Vídeo enviado',
    'pca.sm.productVideoAdded': 'Vídeo do produto adicionado.',
    'pca.sm.couldNotUploadVideo': 'Não foi possível enviar o vídeo.',
    'pca.sm.productUpdateFnUnavailable': 'A função de atualização de produtos não está disponível. Atualize a página.',
    'pca.sm.productUpdated': 'Produto atualizado',
    'pca.sm.productUpdatedDesc': '{name} foi atualizado com sucesso.',
    'pca.sm.errorUpdatingProduct': 'Erro ao atualizar o produto',
    'pca.sm.failedUpdateProduct': 'Falha ao atualizar o produto: {error}',
    'pca.sm.imagesUploadedTitle': 'Imagens enviadas',
    'pca.sm.imagesUploadedComingSoon': '{count} imagem(ns) enviada(s). A galeria do showroom estará disponível em breve.',
    'pca.sm.uploadFailedTitle': 'Falha no envio',
    'pca.sm.couldNotUploadImages': 'Não foi possível enviar as imagens. Tente novamente.',
    'pca.sm.showroomNotAvailable': 'Showroom não disponível',
    'pca.sm.showroomDataNotLoaded': 'Os dados do showroom não foram carregados. Atualize a página e tente novamente.',
    'pca.sm.publicProfilePreview': 'Prévia do perfil público',
    'pca.sm.showingPreview': 'Exibindo a prévia do seu perfil público do showroom em uma nova janela.',
    'pca.sm.previewBlocked': 'Prévia bloqueada',
    'pca.sm.popupBlocked': 'Pop-up bloqueado. Seu showroom está ativo e acessível aos clientes.',
    'pca.sm.showroomDataNotAvailable': 'Dados do showroom não disponíveis. Atualize a página.',
    'pca.sm.editModeEnabled': 'Modo de edição ativado',
    'pca.sm.editModeDesc': "Agora você pode atualizar as descrições e os detalhes do seu showroom. Não esqueça de clicar em '{action}' quando terminar.",
    'pca.sm.replyRequired': 'Resposta obrigatória',
    'pca.sm.enterReplyMessage': 'Digite uma mensagem de resposta.',
    'pca.sm.inquiryNotFound': 'Consulta não encontrada',
    'pca.sm.couldNotFindInquiry': 'Não foi possível encontrar a consulta para responder.',
    'pca.sm.replyFnUnavailable': 'A função de resposta não está disponível. Atualize a página.',
    'pca.sm.businessIdRequiredReplies': 'O ID da empresa é obrigatório para enviar respostas. Atualize e tente novamente.',
    'pca.sm.replySent': 'Resposta enviada com sucesso',
    'pca.sm.replySentDesc': 'Sua resposta foi enviada para {customer}. Status atualizado para "respondido". A caixa de diálogo será fechada em 3 segundos.',
    'pca.sm.errorSendingReply': 'Erro ao enviar a resposta',
    'pca.sm.failedSendReply': 'Falha ao enviar a resposta: {error}',
    'pca.sm.responseRequired': 'Resposta obrigatória',
    'pca.sm.enterResponseMessage': 'Digite uma mensagem de resposta.',
    'pca.sm.reviewNotFound': 'Avaliação não encontrada',
    'pca.sm.couldNotFindReview': 'Não foi possível encontrar a avaliação para responder.',
    'pca.sm.responseFnUnavailable': 'A função de resposta não está disponível. Atualize a página.',
    'pca.sm.businessIdRequiredResponses': 'O ID da empresa é obrigatório para publicar respostas. Atualize e tente novamente.',
    'pca.sm.responsePosted': 'Resposta publicada com sucesso',
    'pca.sm.responsePostedDesc': 'Sua resposta para {customer} foi publicada. Status atualizado para "Respondido". A caixa de diálogo será fechada em 3 segundos.',
    'pca.sm.errorPostingResponse': 'Erro ao publicar a resposta',
    'pca.sm.failedPostResponse': 'Falha ao publicar a resposta: {error}',
    'pca.sm.addressRequired': 'Endereço obrigatório',
    'pca.sm.enterAddressLookup': 'Digite um endereço para buscar a localização.',
    'pca.sm.locationFound': 'Localização encontrada',
    'pca.sm.locationVerifiedUpdated': 'A localização foi verificada e atualizada.',
    'pca.sm.locationError': 'Erro de localização',
    'pca.sm.failedFindLocation': 'Não foi possível encontrar a localização. Verifique o endereço e tente novamente.',
    'pca.sm.creating': 'Criando...',
    'pca.sm.chat': 'Chat',
    'pca.sm.inAppCalls': 'Chamadas no app',
    'pca.sm.noAddressProvided': 'Nenhum endereço fornecido',
    'pca.sm.contactForPrice': 'Consulte o preço',
    'pca.sm.productVideoTitle': 'Vídeo do produto',
    'pca.sm.unpublish': 'Despublicar',
    'pca.sm.publish': 'Publicar',
    'pca.sm.addNewProduct': 'Adicionar novo produto',
    'pca.sm.addShowroomItem': 'Adicionar item ao showroom',
    'pca.sm.editShowroomItem': 'Editar item do showroom',
    'pca.sm.updateItemInfo': 'Atualize as informações do item',
    'pca.sm.noItemsYet': 'Ainda não há itens',
    'pca.sm.addShowroomItemDesc': 'Publique um serviço ou produto no seu showroom público.',
    'pca.sm.itemTypeReq': 'Tipo de item *',
    'pca.sm.itemTypeService': 'Serviço',
    'pca.sm.itemTypeProduct': 'Produto',
    'pca.sm.itemNameReq': 'Nome do item *',
    'pca.sm.serviceNameReq': 'Nome do serviço *',
    'pca.sm.itemImagesOptional': 'Imagens (opcional)',
    'pca.sm.uploadToShowroom': 'Enviar para o showroom',
    'pca.sm.uploadShowroomImages': 'Enviar imagens do showroom',
    'pca.sm.addPhotosGallery': 'Adicione fotos à galeria do seu showroom',
    'pca.sm.dragDropImages': 'Arraste e solte as imagens aqui ou clique para procurar',
    'pca.sm.selectFiles': 'Selecionar arquivos',
    'pca.sm.uploadAndClose': 'Enviar e fechar',
    'pca.sm.viewPublicProfile': 'Ver perfil público',
    'pca.sm.customerInquiries': 'Consultas de clientes',
    'pca.sm.performanceTips': 'Dicas de desempenho',
    'pca.sm.addMoreImages': 'Adicionar mais imagens',
    'pca.sm.images40more': 'Produtos com 3 ou mais imagens recebem 40% mais visualizações',
    'pca.sm.uploadImages': 'Enviar imagens',
    'pca.sm.updateDescriptions': 'Atualizar descrições',
    'pca.sm.detailedDescImprove': 'Descrições detalhadas melhoram a visibilidade nas buscas',
    'pca.sm.editDescriptions': 'Editar descrições',
    'pca.sm.respondToReviews': 'Responder às avaliações',
    'pca.sm.activeEngagement': 'O engajamento ativo gera confiança nos clientes',
    'pca.sm.viewReviews': 'Ver avaliações',
    'pca.sm.createNewShowroom': 'Criar novo showroom',
    'pca.sm.quickCreateShowroom': 'Crie rapidamente um showroom para a sua empresa',
    'pca.sm.create': 'Criar',
    'pca.sm.addProductDesc': 'Adicione um produto ou serviço ao seu showroom',
    'pca.sm.productNameReq': 'Nome do produto *',
    'pca.sm.enterProductName': 'Digite o nome do produto',
    'pca.sm.descriptionReq': 'Descrição *',
    'pca.sm.describeProductService': 'Descreva seu produto ou serviço',
    'pca.sm.price': 'Preço',
    'pca.sm.categoryReq': 'Categoria *',
    'pca.sm.selectCategory': 'Selecione uma categoria…',
    'pca.sm.productImages': 'Imagens do produto',
    'pca.sm.uploading': 'Enviando…',
    'pca.sm.uploadProductImages': 'Enviar imagens do produto',
    'pca.sm.upTo10Images': 'São permitidas até 10 imagens',
    'pca.sm.recommendedFormat': 'Recomendado: 1200x800px, formato JPG/PNG',
    'pca.sm.imagesUploadedCount': '{count} imagem(ns) enviada(s)',
    'pca.sm.productVideo': 'Vídeo do produto',
    'pca.sm.optional': '(opcional)',
    'pca.sm.uploadProductVideo': 'Enviar vídeo do produto',
    'pca.sm.oneVideoPerProduct': 'Um vídeo por produto',
    'pca.sm.videoFormatMax': 'MP4 ou MOV, até 100 MB',
    'pca.sm.videoUploadedLabel': 'Vídeo enviado',
    'pca.sm.showroomAnalytics': 'Análises do showroom',
    'pca.sm.detailedMetrics': 'Métricas de desempenho detalhadas do seu showroom',
    'pca.sm.visitors': 'Visitantes',
    'pca.sm.inquiries': 'Consultas',
    'pca.sm.analyticsNotAvailable': 'As análises detalhadas do showroom ainda não estão disponíveis.',
    'pca.sm.manageInquiries': 'Gerencie as perguntas e solicitações dos clientes',
    'pca.sm.replied': 'Respondido',
    'pca.sm.from': 'De:',
    'pca.sm.yourReply': 'Sua resposta:',
    'pca.sm.repliedOn': 'Respondido em:',
    'pca.sm.unknown': 'Desconhecido',
    'pca.sm.typeReply': 'Digite sua resposta aqui...',
    'pca.sm.sending': 'Enviando...',
    'pca.sm.sendReply': 'Enviar resposta',
    'pca.sm.reply': 'Responder',
    'pca.sm.replyAgain': 'Responder novamente',
    'pca.sm.noInquiriesYet': 'Ainda não há consultas de clientes',
    'pca.sm.customerReviews': 'Avaliações de clientes',
    'pca.sm.respondFeedback': 'Responda aos comentários e às avaliações dos clientes',
    'pca.sm.responded': 'Respondido',
    'pca.sm.new': 'Novo',
    'pca.sm.yourResponse': 'Sua resposta:',
    'pca.sm.respondedOn': 'Respondido em:',
    'pca.sm.thankCustomer': 'Agradeça ao cliente e forneça sua resposta...',
    'pca.sm.posting': 'Publicando...',
    'pca.sm.postResponse': 'Publicar resposta',
    'pca.sm.updateResponse': 'Atualizar resposta',
    'pca.sm.respond': 'Responder',
    'pca.sm.noReviewsYet': 'Ainda não há avaliações de clientes',
    'pca.sm.editProduct': 'Editar produto',
    'pca.sm.updateProductInfo': 'Atualize as informações do produto',
    'pca.sm.describeProduct': 'Descreva seu produto...',
    'pca.sm.currentImagesReplace': 'Imagens atuais ({count}) — enviar novas imagens substitui estas',
    'pca.sm.replaceProductVideo': 'Substituir vídeo do produto',
    'pca.sm.newVideoUploaded': 'Novo vídeo enviado',
    'pca.sm.currentVideo': 'Vídeo atual',
    'pca.sm.removeVideo': 'Remover vídeo',
    'pca.sm.updateProduct': 'Atualizar produto',

    // ---- CreateSurvey ----
    'pca.survey.surveyDetails': 'Detalhes da pesquisa',
    'pca.survey.surveyTitleReq': 'Título da pesquisa *',
    'pca.survey.enterTitle': 'Digite o título da pesquisa',
    'pca.survey.descriptionReq': 'Descrição *',
    'pca.survey.describeSurvey': 'Descreva do que se trata esta pesquisa',
    'pca.survey.surveyTypeReq': 'Tipo de pesquisa *',
    'pca.survey.paidSurvey': 'Pesquisa remunerada',
    'pca.survey.unpaidSurvey': 'Pesquisa não remunerada',
    'pca.survey.reward': 'Recompensa',
    'pca.survey.communityPoints': 'Pontos da comunidade',
    'pca.survey.duration': 'Duração',
    'pca.survey.durationExample': '5-10 minutos',
    'pca.survey.difficulty': 'Dificuldade',
    'pca.survey.easy': 'Fácil',
    'pca.survey.medium': 'Média',
    'pca.survey.advanced': 'Avançada',
    'pca.survey.deadlineReq': 'Prazo *',
    'pca.survey.addQuestions': 'Adicionar perguntas',
    'pca.survey.questionType': 'Tipo de pergunta',
    'pca.survey.questionReq': 'Pergunta *',
    'pca.survey.enterYourQuestion': 'Digite sua pergunta',
    'pca.survey.options': 'Opções',
    'pca.survey.optionN': 'Opção {n}',
    'pca.survey.addOption': 'Adicionar opção',
    'pca.survey.requiredQuestion': 'Pergunta obrigatória',
    'pca.survey.addQuestion': 'Adicionar pergunta',
    'pca.survey.questionsCount': 'Perguntas ({count})',
    'pca.survey.required': 'Obrigatória',
    'pca.survey.creatingSurvey': 'Criando pesquisa...',
    'pca.survey.preview': 'Prévia',
    'pca.survey.details': 'Detalhes',
    'pca.survey.audience': 'Público',
    'pca.survey.typeLabel': 'Tipo:',
    'pca.survey.paid': 'Remunerada',
    'pca.survey.unpaid': 'Não remunerada',
    'pca.survey.rewardLabel': 'Recompensa:',
    'pca.survey.durationLabel': 'Duração:',
    'pca.survey.difficultyLabel': 'Dificuldade:',
    'pca.survey.questionsLabel': 'Perguntas:',
    'pca.survey.fillToPreview': 'Preencha os detalhes da pesquisa para ver a prévia',
    'pca.survey.targetAll': 'Alvo: Todos os clientes de {business}',
    'pca.survey.yourBusiness': 'sua empresa',
    'pca.survey.deadlineLabel': 'Prazo:',
    'pca.survey.requiredQuestions': '{count} pergunta(s) obrigatória(s)',
    'pca.survey.totalQuestions': '{count} pergunta(s) adicionada(s) no total',
    'pca.survey.surveyTips': 'Dicas de pesquisa',
    'pca.survey.tip1': 'Mantenha as perguntas claras e concisas',
    'pca.survey.tip2': 'Use uma combinação de tipos de pergunta para aumentar o engajamento',
    'pca.survey.tip3': 'Ofereça recompensas adequadas à duração da pesquisa',
    'pca.survey.tip4': 'Teste sua pesquisa antes de publicar',
    'pca.survey.tip5': 'Defina prazos realistas',
  },
  de: {
    // ---- ShowroomManager ----
    'pca.sm.productPublished': 'Produkt veröffentlicht',
    'pca.sm.correctionRequested': 'Korrektur angefordert',
    'pca.sm.correctionAccepted': 'Korrektur akzeptiert',
    'pca.sm.showroomRequiredHint': 'Erstellen Sie Ihren Showroom, bevor Sie Marketplace-Artikel hinzufügen.',
    'pca.sm.correctionAwaitingReview': 'Korrektur eingereicht — wird geprüft',
    'pca.sm.correctionRequestedAt': 'Angefordert am',
    'pca.sm.correctionEditHint': 'Bearbeiten Sie diesen Eintrag entsprechend der Anforderung und speichern Sie.',
    'pca.sm.correctionSubmittedHint': 'Ihre Änderung wurde eingereicht. Servisfy prüft sie.',
    'pca.sm.productHidden': 'Produkt ausgeblendet',
    'pca.sm.productNowActive': '{name} ist jetzt aktiv.',
    'pca.sm.productNowHidden': '{name} ist jetzt ausgeblendet.',
    'pca.sm.updateFailed': 'Aktualisierung fehlgeschlagen',
    'pca.sm.confirmDeleteProduct': '„{name}“ löschen? Dies kann nicht rückgängig gemacht werden.',
    'pca.sm.productDeleted': 'Produkt gelöscht',
    'pca.sm.productWasRemoved': '{name} wurde entfernt.',
    'pca.sm.deleteFailed': 'Löschen fehlgeschlagen',
    'pca.sm.formError': 'Formularfehler',
    'pca.sm.formNotInit': 'Die Formulardaten wurden nicht ordnungsgemäß initialisiert.',
    'pca.sm.validationError': 'Validierungsfehler',
    'pca.sm.fillRequiredFields': 'Bitte füllen Sie alle Pflichtfelder aus.',
    'pca.sm.authError': 'Authentifizierungsfehler',
    'pca.sm.businessIdRequiredLogin': 'Die Geschäfts-ID des Benutzers ist erforderlich. Bitte melden Sie sich erneut an.',
    'pca.sm.showroomUpdated': 'Showroom aktualisiert',
    'pca.sm.showroomUpdatedDesc': 'Die Angaben Ihres Showrooms wurden erfolgreich aktualisiert!',
    'pca.sm.showroomCreated': 'Showroom erstellt',
    'pca.sm.showroomCreatedDesc': 'Ihr Showroom wurde erfolgreich erstellt!',
    'pca.sm.failedSaveShowroom': 'Showroom konnte nicht gespeichert werden. Bitte versuchen Sie es erneut.',
    'pca.sm.productNameDescRequired': 'Produktname und Beschreibung sind erforderlich.',
    'pca.sm.categoryRequired': 'Kategorie erforderlich',
    'pca.sm.selectCategoryBeforeSaving': 'Bitte wählen Sie vor dem Speichern eine Produktkategorie aus.',
    'pca.sm.functionNotAvailable': 'Funktion nicht verfügbar',
    'pca.sm.productCreateFnUnavailable': 'Die Funktion zum Erstellen von Produkten ist nicht verfügbar. Bitte aktualisieren Sie die Seite.',
    'pca.sm.productAddedTitle': 'Produkt erfolgreich hinzugefügt',
    'pca.sm.productAddedDesc': '{name} wurde zu Ihrem Showroom hinzugefügt und ist jetzt unter Produkte & Dienstleistungen sichtbar.',
    'pca.sm.errorAddingProduct': 'Fehler beim Hinzufügen des Produkts',
    'pca.sm.failedAddProduct': 'Produkt konnte nicht hinzugefügt werden: {error}',
    'pca.sm.unknownErrorOccurred': 'Ein unbekannter Fehler ist aufgetreten',
    'pca.sm.unknownError': 'Unbekannter Fehler',
    'pca.sm.tooManyImages': 'Zu viele Bilder',
    'pca.sm.selectUpTo10': 'Bitte wählen Sie insgesamt maximal 10 Bilder aus.',
    'pca.sm.unsupportedFile': 'Nicht unterstützte Datei',
    'pca.sm.onlyImageTypes': '{name}: Es sind nur JPEG-, PNG- oder WebP-Bilder zulässig.',
    'pca.sm.fileTooLarge': 'Datei zu groß',
    'pca.sm.imageMaxSize': '{name}: Bilder dürfen maximal 10 MB groß sein.',
    'pca.sm.imagesUploaded': 'Bilder hochgeladen',
    'pca.sm.imagesAdded': '{count} Bild(er) hinzugefügt.',
    'pca.sm.uploadFailed': 'Upload fehlgeschlagen',
    'pca.sm.couldNotUploadImage': 'Bild konnte nicht hochgeladen werden.',
    'pca.sm.onlyVideoTypes': '{name}: Es sind nur MP4- oder MOV-Videos zulässig.',
    'pca.sm.videoMaxSize': '{name}: Videos dürfen maximal 100 MB groß sein.',
    'pca.sm.videoUploaded': 'Video hochgeladen',
    'pca.sm.productVideoAdded': 'Produktvideo hinzugefügt.',
    'pca.sm.couldNotUploadVideo': 'Video konnte nicht hochgeladen werden.',
    'pca.sm.productUpdateFnUnavailable': 'Die Funktion zum Aktualisieren von Produkten ist nicht verfügbar. Bitte aktualisieren Sie die Seite.',
    'pca.sm.productUpdated': 'Produkt aktualisiert',
    'pca.sm.productUpdatedDesc': '{name} wurde erfolgreich aktualisiert.',
    'pca.sm.errorUpdatingProduct': 'Fehler beim Aktualisieren des Produkts',
    'pca.sm.failedUpdateProduct': 'Produkt konnte nicht aktualisiert werden: {error}',
    'pca.sm.imagesUploadedTitle': 'Bilder hochgeladen',
    'pca.sm.imagesUploadedComingSoon': '{count} Bild(er) hochgeladen. Die Showroom-Galerie folgt in Kürze.',
    'pca.sm.uploadFailedTitle': 'Upload fehlgeschlagen',
    'pca.sm.couldNotUploadImages': 'Bilder konnten nicht hochgeladen werden. Bitte versuchen Sie es erneut.',
    'pca.sm.showroomNotAvailable': 'Showroom nicht verfügbar',
    'pca.sm.showroomDataNotLoaded': 'Showroom-Daten nicht geladen. Bitte aktualisieren Sie die Seite und versuchen Sie es erneut.',
    'pca.sm.publicProfilePreview': 'Vorschau des öffentlichen Profils',
    'pca.sm.showingPreview': 'Vorschau Ihres öffentlichen Showroom-Profils wird in einem neuen Fenster angezeigt.',
    'pca.sm.previewBlocked': 'Vorschau blockiert',
    'pca.sm.popupBlocked': 'Pop-up blockiert. Ihr Showroom ist online und für Kunden zugänglich.',
    'pca.sm.showroomDataNotAvailable': 'Showroom-Daten nicht verfügbar. Bitte aktualisieren Sie die Seite.',
    'pca.sm.editModeEnabled': 'Bearbeitungsmodus aktiviert',
    'pca.sm.editModeDesc': "Sie können jetzt die Beschreibungen und Details Ihres Showrooms aktualisieren. Vergessen Sie nicht, am Ende auf „{action}“ zu klicken.",
    'pca.sm.replyRequired': 'Antwort erforderlich',
    'pca.sm.enterReplyMessage': 'Bitte geben Sie eine Antwortnachricht ein.',
    'pca.sm.inquiryNotFound': 'Anfrage nicht gefunden',
    'pca.sm.couldNotFindInquiry': 'Die zu beantwortende Anfrage konnte nicht gefunden werden.',
    'pca.sm.replyFnUnavailable': 'Die Antwortfunktion ist nicht verfügbar. Bitte aktualisieren Sie die Seite.',
    'pca.sm.businessIdRequiredReplies': 'Die Geschäfts-ID ist zum Senden von Antworten erforderlich. Bitte aktualisieren und erneut versuchen.',
    'pca.sm.replySent': 'Antwort erfolgreich gesendet',
    'pca.sm.replySentDesc': 'Ihre Antwort wurde an {customer} gesendet. Status auf „beantwortet“ aktualisiert. Das Dialogfeld wird in 3 Sekunden geschlossen.',
    'pca.sm.errorSendingReply': 'Fehler beim Senden der Antwort',
    'pca.sm.failedSendReply': 'Antwort konnte nicht gesendet werden: {error}',
    'pca.sm.responseRequired': 'Antwort erforderlich',
    'pca.sm.enterResponseMessage': 'Bitte geben Sie eine Antwortnachricht ein.',
    'pca.sm.reviewNotFound': 'Bewertung nicht gefunden',
    'pca.sm.couldNotFindReview': 'Die zu beantwortende Bewertung konnte nicht gefunden werden.',
    'pca.sm.responseFnUnavailable': 'Die Antwortfunktion ist nicht verfügbar. Bitte aktualisieren Sie die Seite.',
    'pca.sm.businessIdRequiredResponses': 'Die Geschäfts-ID ist zum Veröffentlichen von Antworten erforderlich. Bitte aktualisieren und erneut versuchen.',
    'pca.sm.responsePosted': 'Antwort erfolgreich veröffentlicht',
    'pca.sm.responsePostedDesc': 'Ihre Antwort an {customer} wurde veröffentlicht. Status auf „Beantwortet“ aktualisiert. Das Dialogfeld wird in 3 Sekunden geschlossen.',
    'pca.sm.errorPostingResponse': 'Fehler beim Veröffentlichen der Antwort',
    'pca.sm.failedPostResponse': 'Antwort konnte nicht veröffentlicht werden: {error}',
    'pca.sm.addressRequired': 'Adresse erforderlich',
    'pca.sm.enterAddressLookup': 'Bitte geben Sie eine Adresse ein, um den Standort zu suchen.',
    'pca.sm.locationFound': 'Standort gefunden',
    'pca.sm.locationVerifiedUpdated': 'Der Standort wurde überprüft und aktualisiert.',
    'pca.sm.locationError': 'Standortfehler',
    'pca.sm.failedFindLocation': 'Standort konnte nicht gefunden werden. Bitte überprüfen Sie die Adresse und versuchen Sie es erneut.',
    'pca.sm.creating': 'Wird erstellt...',
    'pca.sm.chat': 'Chat',
    'pca.sm.inAppCalls': 'In-App-Anrufe',
    'pca.sm.noAddressProvided': 'Keine Adresse angegeben',
    'pca.sm.contactForPrice': 'Preis auf Anfrage',
    'pca.sm.productVideoTitle': 'Produktvideo',
    'pca.sm.unpublish': 'Veröffentlichung aufheben',
    'pca.sm.publish': 'Veröffentlichen',
    'pca.sm.addNewProduct': 'Neues Produkt hinzufügen',
    'pca.sm.addShowroomItem': 'Showroom-Eintrag hinzufügen',
    'pca.sm.editShowroomItem': 'Showroom-Eintrag bearbeiten',
    'pca.sm.updateItemInfo': 'Eintragsinformationen aktualisieren',
    'pca.sm.noItemsYet': 'Noch keine Einträge',
    'pca.sm.addShowroomItemDesc': 'Veröffentlichen Sie eine Dienstleistung oder ein Produkt in Ihrem öffentlichen Showroom.',
    'pca.sm.itemTypeReq': 'Eintragstyp *',
    'pca.sm.itemTypeService': 'Dienstleistung',
    'pca.sm.itemTypeProduct': 'Produkt',
    'pca.sm.itemNameReq': 'Name des Eintrags *',
    'pca.sm.serviceNameReq': 'Name der Dienstleistung *',
    'pca.sm.itemImagesOptional': 'Bilder (optional)',
    'pca.sm.uploadToShowroom': 'In den Showroom hochladen',
    'pca.sm.uploadShowroomImages': 'Showroom-Bilder hochladen',
    'pca.sm.addPhotosGallery': 'Fügen Sie Fotos zu Ihrer Showroom-Galerie hinzu',
    'pca.sm.dragDropImages': 'Bilder hierher ziehen und ablegen oder zum Durchsuchen klicken',
    'pca.sm.selectFiles': 'Dateien auswählen',
    'pca.sm.uploadAndClose': 'Hochladen & schließen',
    'pca.sm.viewPublicProfile': 'Öffentliches Profil ansehen',
    'pca.sm.customerInquiries': 'Kundenanfragen',
    'pca.sm.performanceTips': 'Leistungstipps',
    'pca.sm.addMoreImages': 'Weitere Bilder hinzufügen',
    'pca.sm.images40more': 'Produkte mit 3+ Bildern erhalten 40 % mehr Aufrufe',
    'pca.sm.uploadImages': 'Bilder hochladen',
    'pca.sm.updateDescriptions': 'Beschreibungen aktualisieren',
    'pca.sm.detailedDescImprove': 'Detaillierte Beschreibungen verbessern die Sichtbarkeit in der Suche',
    'pca.sm.editDescriptions': 'Beschreibungen bearbeiten',
    'pca.sm.respondToReviews': 'Auf Bewertungen antworten',
    'pca.sm.activeEngagement': 'Aktives Engagement schafft Kundenvertrauen',
    'pca.sm.viewReviews': 'Bewertungen ansehen',
    'pca.sm.createNewShowroom': 'Neuen Showroom erstellen',
    'pca.sm.quickCreateShowroom': 'Erstellen Sie schnell einen Showroom für Ihr Unternehmen',
    'pca.sm.create': 'Erstellen',
    'pca.sm.addProductDesc': 'Fügen Sie Ihrem Showroom ein Produkt oder eine Dienstleistung hinzu',
    'pca.sm.productNameReq': 'Produktname *',
    'pca.sm.enterProductName': 'Produktnamen eingeben',
    'pca.sm.descriptionReq': 'Beschreibung *',
    'pca.sm.describeProductService': 'Beschreiben Sie Ihr Produkt oder Ihre Dienstleistung',
    'pca.sm.price': 'Preis',
    'pca.sm.categoryReq': 'Kategorie *',
    'pca.sm.selectCategory': 'Kategorie auswählen…',
    'pca.sm.productImages': 'Produktbilder',
    'pca.sm.uploading': 'Wird hochgeladen…',
    'pca.sm.uploadProductImages': 'Produktbilder hochladen',
    'pca.sm.upTo10Images': 'Bis zu 10 Bilder erlaubt',
    'pca.sm.recommendedFormat': 'Empfohlen: 1200x800px, JPG/PNG-Format',
    'pca.sm.imagesUploadedCount': '{count} Bild(er) hochgeladen',
    'pca.sm.productVideo': 'Produktvideo',
    'pca.sm.optional': '(optional)',
    'pca.sm.uploadProductVideo': 'Produktvideo hochladen',
    'pca.sm.oneVideoPerProduct': 'Ein Video pro Produkt',
    'pca.sm.videoFormatMax': 'MP4 oder MOV, bis zu 100 MB',
    'pca.sm.videoUploadedLabel': 'Video hochgeladen',
    'pca.sm.showroomAnalytics': 'Showroom-Analysen',
    'pca.sm.detailedMetrics': 'Detaillierte Leistungskennzahlen für Ihren Showroom',
    'pca.sm.visitors': 'Besucher',
    'pca.sm.inquiries': 'Anfragen',
    'pca.sm.analyticsNotAvailable': 'Detaillierte Showroom-Analysen sind noch nicht verfügbar.',
    'pca.sm.manageInquiries': 'Verwalten Sie Kundenfragen und -anfragen',
    'pca.sm.replied': 'Beantwortet',
    'pca.sm.from': 'Von:',
    'pca.sm.yourReply': 'Ihre Antwort:',
    'pca.sm.repliedOn': 'Beantwortet am:',
    'pca.sm.unknown': 'Unbekannt',
    'pca.sm.typeReply': 'Geben Sie hier Ihre Antwort ein...',
    'pca.sm.sending': 'Wird gesendet...',
    'pca.sm.sendReply': 'Antwort senden',
    'pca.sm.reply': 'Antworten',
    'pca.sm.replyAgain': 'Erneut antworten',
    'pca.sm.noInquiriesYet': 'Noch keine Kundenanfragen',
    'pca.sm.customerReviews': 'Kundenbewertungen',
    'pca.sm.respondFeedback': 'Antworten Sie auf Kundenfeedback und -bewertungen',
    'pca.sm.responded': 'Beantwortet',
    'pca.sm.new': 'Neu',
    'pca.sm.yourResponse': 'Ihre Antwort:',
    'pca.sm.respondedOn': 'Beantwortet am:',
    'pca.sm.thankCustomer': 'Danken Sie dem Kunden und geben Sie Ihre Antwort ein...',
    'pca.sm.posting': 'Wird veröffentlicht...',
    'pca.sm.postResponse': 'Antwort veröffentlichen',
    'pca.sm.updateResponse': 'Antwort aktualisieren',
    'pca.sm.respond': 'Antworten',
    'pca.sm.noReviewsYet': 'Noch keine Kundenbewertungen',
    'pca.sm.editProduct': 'Produkt bearbeiten',
    'pca.sm.updateProductInfo': 'Aktualisieren Sie die Produktinformationen',
    'pca.sm.describeProduct': 'Beschreiben Sie Ihr Produkt...',
    'pca.sm.currentImagesReplace': 'Aktuelle Bilder ({count}) — das Hochladen neuer Bilder ersetzt diese',
    'pca.sm.replaceProductVideo': 'Produktvideo ersetzen',
    'pca.sm.newVideoUploaded': 'Neues Video hochgeladen',
    'pca.sm.currentVideo': 'Aktuelles Video',
    'pca.sm.removeVideo': 'Video entfernen',
    'pca.sm.updateProduct': 'Produkt aktualisieren',

    // ---- CreateSurvey ----
    'pca.survey.surveyDetails': 'Umfragedetails',
    'pca.survey.surveyTitleReq': 'Umfragetitel *',
    'pca.survey.enterTitle': 'Umfragetitel eingeben',
    'pca.survey.descriptionReq': 'Beschreibung *',
    'pca.survey.describeSurvey': 'Beschreiben Sie, worum es in dieser Umfrage geht',
    'pca.survey.surveyTypeReq': 'Umfragetyp *',
    'pca.survey.paidSurvey': 'Bezahlte Umfrage',
    'pca.survey.unpaidSurvey': 'Unbezahlte Umfrage',
    'pca.survey.reward': 'Belohnung',
    'pca.survey.communityPoints': 'Community-Punkte',
    'pca.survey.duration': 'Dauer',
    'pca.survey.durationExample': '5-10 Minuten',
    'pca.survey.difficulty': 'Schwierigkeit',
    'pca.survey.easy': 'Einfach',
    'pca.survey.medium': 'Mittel',
    'pca.survey.advanced': 'Fortgeschritten',
    'pca.survey.deadlineReq': 'Frist *',
    'pca.survey.addQuestions': 'Fragen hinzufügen',
    'pca.survey.questionType': 'Fragetyp',
    'pca.survey.questionReq': 'Frage *',
    'pca.survey.enterYourQuestion': 'Geben Sie Ihre Frage ein',
    'pca.survey.options': 'Optionen',
    'pca.survey.optionN': 'Option {n}',
    'pca.survey.addOption': 'Option hinzufügen',
    'pca.survey.requiredQuestion': 'Pflichtfrage',
    'pca.survey.addQuestion': 'Frage hinzufügen',
    'pca.survey.questionsCount': 'Fragen ({count})',
    'pca.survey.required': 'Pflichtfeld',
    'pca.survey.creatingSurvey': 'Umfrage wird erstellt...',
    'pca.survey.preview': 'Vorschau',
    'pca.survey.details': 'Details',
    'pca.survey.audience': 'Zielgruppe',
    'pca.survey.typeLabel': 'Typ:',
    'pca.survey.paid': 'Bezahlt',
    'pca.survey.unpaid': 'Unbezahlt',
    'pca.survey.rewardLabel': 'Belohnung:',
    'pca.survey.durationLabel': 'Dauer:',
    'pca.survey.difficultyLabel': 'Schwierigkeit:',
    'pca.survey.questionsLabel': 'Fragen:',
    'pca.survey.fillToPreview': 'Füllen Sie die Umfragedetails aus, um die Vorschau zu sehen',
    'pca.survey.targetAll': 'Ziel: Alle Kunden von {business}',
    'pca.survey.yourBusiness': 'Ihr Unternehmen',
    'pca.survey.deadlineLabel': 'Frist:',
    'pca.survey.requiredQuestions': '{count} Pflichtfrage(n)',
    'pca.survey.totalQuestions': '{count} Frage(n) insgesamt hinzugefügt',
    'pca.survey.surveyTips': 'Umfragetipps',
    'pca.survey.tip1': 'Halten Sie Fragen klar und prägnant',
    'pca.survey.tip2': 'Verwenden Sie eine Mischung aus Fragetypen für mehr Engagement',
    'pca.survey.tip3': 'Bieten Sie angemessene Belohnungen für die Umfragelänge',
    'pca.survey.tip4': 'Testen Sie Ihre Umfrage vor der Veröffentlichung',
    'pca.survey.tip5': 'Setzen Sie realistische Fristen',
  },
  it: {
    // ---- ShowroomManager ----
    'pca.sm.productPublished': 'Prodotto pubblicato',
    'pca.sm.correctionRequested': 'Correzione richiesta',
    'pca.sm.correctionAccepted': 'Correzione accettata',
    'pca.sm.showroomRequiredHint': 'Crea il tuo Showroom prima di aggiungere articoli al Marketplace.',
    'pca.sm.correctionAwaitingReview': 'Correzione inviata — in attesa di revisione',
    'pca.sm.correctionRequestedAt': 'Richiesto il',
    'pca.sm.correctionEditHint': 'Modifica questo annuncio per rispondere alla richiesta, poi salva.',
    'pca.sm.correctionSubmittedHint': 'Il tuo aggiornamento è stato inviato. Servisfy lo esaminerà.',
    'pca.sm.productHidden': 'Prodotto nascosto',
    'pca.sm.productNowActive': '{name} ora è attivo.',
    'pca.sm.productNowHidden': '{name} ora è nascosto.',
    'pca.sm.updateFailed': 'Aggiornamento non riuscito',
    'pca.sm.confirmDeleteProduct': 'Eliminare "{name}"? Questa azione non può essere annullata.',
    'pca.sm.productDeleted': 'Prodotto eliminato',
    'pca.sm.productWasRemoved': '{name} è stato rimosso.',
    'pca.sm.deleteFailed': 'Eliminazione non riuscita',
    'pca.sm.formError': 'Errore del modulo',
    'pca.sm.formNotInit': 'I dati del modulo non sono stati inizializzati correttamente.',
    'pca.sm.validationError': 'Errore di convalida',
    'pca.sm.fillRequiredFields': 'Compila tutti i campi obbligatori.',
    'pca.sm.authError': 'Errore di autenticazione',
    'pca.sm.businessIdRequiredLogin': "È richiesto l'ID aziendale dell'utente. Effettua di nuovo l'accesso.",
    'pca.sm.showroomUpdated': 'Showroom aggiornato',
    'pca.sm.showroomUpdatedDesc': 'I dettagli del tuo showroom sono stati aggiornati con successo!',
    'pca.sm.showroomCreated': 'Showroom creato',
    'pca.sm.showroomCreatedDesc': 'Il tuo showroom è stato creato con successo!',
    'pca.sm.failedSaveShowroom': 'Impossibile salvare lo showroom. Riprova.',
    'pca.sm.productNameDescRequired': 'Il nome e la descrizione del prodotto sono obbligatori.',
    'pca.sm.categoryRequired': 'Categoria obbligatoria',
    'pca.sm.selectCategoryBeforeSaving': 'Seleziona una categoria di prodotto prima di salvare.',
    'pca.sm.functionNotAvailable': 'Funzione non disponibile',
    'pca.sm.productCreateFnUnavailable': 'La funzione di creazione dei prodotti non è disponibile. Aggiorna la pagina.',
    'pca.sm.productAddedTitle': 'Prodotto aggiunto con successo',
    'pca.sm.productAddedDesc': '{name} è stato aggiunto al tuo showroom ed è ora visibile in Prodotti e Servizi.',
    'pca.sm.errorAddingProduct': "Errore durante l'aggiunta del prodotto",
    'pca.sm.failedAddProduct': 'Impossibile aggiungere il prodotto: {error}',
    'pca.sm.unknownErrorOccurred': 'Si è verificato un errore sconosciuto',
    'pca.sm.unknownError': 'Errore sconosciuto',
    'pca.sm.tooManyImages': 'Troppe immagini',
    'pca.sm.selectUpTo10': 'Seleziona un massimo di 10 immagini in totale.',
    'pca.sm.unsupportedFile': 'File non supportato',
    'pca.sm.onlyImageTypes': '{name}: sono consentite solo immagini JPEG, PNG o WebP.',
    'pca.sm.fileTooLarge': 'File troppo grande',
    'pca.sm.imageMaxSize': '{name}: le immagini devono essere di 10 MB o meno.',
    'pca.sm.imagesUploaded': 'Immagini caricate',
    'pca.sm.imagesAdded': '{count} immagine/i aggiunta/e.',
    'pca.sm.uploadFailed': 'Caricamento non riuscito',
    'pca.sm.couldNotUploadImage': "Impossibile caricare l'immagine.",
    'pca.sm.onlyVideoTypes': '{name}: sono consentiti solo video MP4 o MOV.',
    'pca.sm.videoMaxSize': '{name}: i video devono essere di 100 MB o meno.',
    'pca.sm.videoUploaded': 'Video caricato',
    'pca.sm.productVideoAdded': 'Video del prodotto aggiunto.',
    'pca.sm.couldNotUploadVideo': 'Impossibile caricare il video.',
    'pca.sm.productUpdateFnUnavailable': "La funzione di aggiornamento dei prodotti non è disponibile. Aggiorna la pagina.",
    'pca.sm.productUpdated': 'Prodotto aggiornato',
    'pca.sm.productUpdatedDesc': '{name} è stato aggiornato con successo.',
    'pca.sm.errorUpdatingProduct': "Errore durante l'aggiornamento del prodotto",
    'pca.sm.failedUpdateProduct': "Impossibile aggiornare il prodotto: {error}",
    'pca.sm.imagesUploadedTitle': 'Immagini caricate',
    'pca.sm.imagesUploadedComingSoon': '{count} immagine/i caricata/e. La galleria dello showroom sarà presto disponibile.',
    'pca.sm.uploadFailedTitle': 'Caricamento non riuscito',
    'pca.sm.couldNotUploadImages': 'Impossibile caricare le immagini. Riprova.',
    'pca.sm.showroomNotAvailable': 'Showroom non disponibile',
    'pca.sm.showroomDataNotLoaded': 'Dati dello showroom non caricati. Aggiorna la pagina e riprova.',
    'pca.sm.publicProfilePreview': 'Anteprima del profilo pubblico',
    'pca.sm.showingPreview': "Anteprima del tuo profilo pubblico dello showroom mostrata in una nuova finestra.",
    'pca.sm.previewBlocked': 'Anteprima bloccata',
    'pca.sm.popupBlocked': 'Popup bloccato. Il tuo showroom è online e accessibile ai clienti.',
    'pca.sm.showroomDataNotAvailable': 'Dati dello showroom non disponibili. Aggiorna la pagina.',
    'pca.sm.editModeEnabled': 'Modalità di modifica attivata',
    'pca.sm.editModeDesc': "Ora puoi aggiornare le descrizioni e i dettagli del tuo showroom. Non dimenticare di fare clic su \"{action}\" al termine.",
    'pca.sm.replyRequired': 'Risposta obbligatoria',
    'pca.sm.enterReplyMessage': 'Inserisci un messaggio di risposta.',
    'pca.sm.inquiryNotFound': 'Richiesta non trovata',
    'pca.sm.couldNotFindInquiry': 'Impossibile trovare la richiesta a cui rispondere.',
    'pca.sm.replyFnUnavailable': 'La funzione di risposta non è disponibile. Aggiorna la pagina.',
    'pca.sm.businessIdRequiredReplies': "È richiesto l'ID aziendale per inviare risposte. Aggiorna e riprova.",
    'pca.sm.replySent': 'Risposta inviata con successo',
    'pca.sm.replySentDesc': 'La tua risposta è stata inviata a {customer}. Stato aggiornato a "risposto". La finestra di dialogo si chiuderà tra 3 secondi.',
    'pca.sm.errorSendingReply': "Errore durante l'invio della risposta",
    'pca.sm.failedSendReply': "Impossibile inviare la risposta: {error}",
    'pca.sm.responseRequired': 'Risposta obbligatoria',
    'pca.sm.enterResponseMessage': 'Inserisci un messaggio di risposta.',
    'pca.sm.reviewNotFound': 'Recensione non trovata',
    'pca.sm.couldNotFindReview': 'Impossibile trovare la recensione a cui rispondere.',
    'pca.sm.responseFnUnavailable': 'La funzione di risposta non è disponibile. Aggiorna la pagina.',
    'pca.sm.businessIdRequiredResponses': "È richiesto l'ID aziendale per pubblicare risposte. Aggiorna e riprova.",
    'pca.sm.responsePosted': 'Risposta pubblicata con successo',
    'pca.sm.responsePostedDesc': 'La tua risposta a {customer} è stata pubblicata. Stato aggiornato a "Risposto". La finestra di dialogo si chiuderà tra 3 secondi.',
    'pca.sm.errorPostingResponse': 'Errore durante la pubblicazione della risposta',
    'pca.sm.failedPostResponse': 'Impossibile pubblicare la risposta: {error}',
    'pca.sm.addressRequired': 'Indirizzo obbligatorio',
    'pca.sm.enterAddressLookup': 'Inserisci un indirizzo per cercare la posizione.',
    'pca.sm.locationFound': 'Posizione trovata',
    'pca.sm.locationVerifiedUpdated': 'La posizione è stata verificata e aggiornata.',
    'pca.sm.locationError': 'Errore di posizione',
    'pca.sm.failedFindLocation': "Impossibile trovare la posizione. Verifica l'indirizzo e riprova.",
    'pca.sm.creating': 'Creazione in corso...',
    'pca.sm.chat': 'Chat',
    'pca.sm.inAppCalls': "Chiamate nell'app",
    'pca.sm.noAddressProvided': 'Nessun indirizzo fornito',
    'pca.sm.contactForPrice': 'Prezzo su richiesta',
    'pca.sm.productVideoTitle': 'Video del prodotto',
    'pca.sm.unpublish': 'Annulla pubblicazione',
    'pca.sm.publish': 'Pubblica',
    'pca.sm.addNewProduct': 'Aggiungi nuovo prodotto',
    'pca.sm.addShowroomItem': 'Aggiungi elemento allo showroom',
    'pca.sm.editShowroomItem': 'Modifica elemento dello showroom',
    'pca.sm.updateItemInfo': 'Aggiorna le informazioni dell\'elemento',
    'pca.sm.noItemsYet': 'Nessun elemento',
    'pca.sm.addShowroomItemDesc': 'Pubblica un servizio o un prodotto nel tuo showroom pubblico.',
    'pca.sm.itemTypeReq': 'Tipo di elemento *',
    'pca.sm.itemTypeService': 'Servizio',
    'pca.sm.itemTypeProduct': 'Prodotto',
    'pca.sm.itemNameReq': 'Nome dell\'elemento *',
    'pca.sm.serviceNameReq': 'Nome del servizio *',
    'pca.sm.itemImagesOptional': 'Immagini (facoltativo)',
    'pca.sm.uploadToShowroom': 'Carica nello showroom',
    'pca.sm.uploadShowroomImages': 'Carica immagini dello showroom',
    'pca.sm.addPhotosGallery': 'Aggiungi foto alla galleria del tuo showroom',
    'pca.sm.dragDropImages': 'Trascina e rilascia le immagini qui, oppure fai clic per sfogliare',
    'pca.sm.selectFiles': 'Seleziona file',
    'pca.sm.uploadAndClose': 'Carica e chiudi',
    'pca.sm.viewPublicProfile': 'Visualizza profilo pubblico',
    'pca.sm.customerInquiries': 'Richieste dei clienti',
    'pca.sm.performanceTips': 'Suggerimenti sulle prestazioni',
    'pca.sm.addMoreImages': 'Aggiungi più immagini',
    'pca.sm.images40more': 'I prodotti con 3 o più immagini ottengono il 40% di visualizzazioni in più',
    'pca.sm.uploadImages': 'Carica immagini',
    'pca.sm.updateDescriptions': 'Aggiorna descrizioni',
    'pca.sm.detailedDescImprove': 'Descrizioni dettagliate migliorano la visibilità nelle ricerche',
    'pca.sm.editDescriptions': 'Modifica descrizioni',
    'pca.sm.respondToReviews': 'Rispondi alle recensioni',
    'pca.sm.activeEngagement': 'Un coinvolgimento attivo crea fiducia nei clienti',
    'pca.sm.viewReviews': 'Visualizza recensioni',
    'pca.sm.createNewShowroom': 'Crea nuovo showroom',
    'pca.sm.quickCreateShowroom': 'Crea rapidamente uno showroom per la tua azienda',
    'pca.sm.create': 'Crea',
    'pca.sm.addProductDesc': 'Aggiungi un prodotto o un servizio al tuo showroom',
    'pca.sm.productNameReq': 'Nome del prodotto *',
    'pca.sm.enterProductName': 'Inserisci il nome del prodotto',
    'pca.sm.descriptionReq': 'Descrizione *',
    'pca.sm.describeProductService': 'Descrivi il tuo prodotto o servizio',
    'pca.sm.price': 'Prezzo',
    'pca.sm.categoryReq': 'Categoria *',
    'pca.sm.selectCategory': 'Seleziona una categoria…',
    'pca.sm.productImages': 'Immagini del prodotto',
    'pca.sm.uploading': 'Caricamento…',
    'pca.sm.uploadProductImages': 'Carica immagini del prodotto',
    'pca.sm.upTo10Images': 'Sono consentite fino a 10 immagini',
    'pca.sm.recommendedFormat': 'Consigliato: 1200x800px, formato JPG/PNG',
    'pca.sm.imagesUploadedCount': '{count} immagine/i caricata/e',
    'pca.sm.productVideo': 'Video del prodotto',
    'pca.sm.optional': '(facoltativo)',
    'pca.sm.uploadProductVideo': 'Carica video del prodotto',
    'pca.sm.oneVideoPerProduct': 'Un video per prodotto',
    'pca.sm.videoFormatMax': 'MP4 o MOV, fino a 100 MB',
    'pca.sm.videoUploadedLabel': 'Video caricato',
    'pca.sm.showroomAnalytics': 'Analisi dello showroom',
    'pca.sm.detailedMetrics': 'Metriche di prestazione dettagliate per il tuo showroom',
    'pca.sm.visitors': 'Visitatori',
    'pca.sm.inquiries': 'Richieste',
    'pca.sm.analyticsNotAvailable': 'Le analisi dettagliate dello showroom non sono ancora disponibili.',
    'pca.sm.manageInquiries': 'Gestisci le domande e le richieste dei clienti',
    'pca.sm.replied': 'Risposto',
    'pca.sm.from': 'Da:',
    'pca.sm.yourReply': 'La tua risposta:',
    'pca.sm.repliedOn': 'Risposto il:',
    'pca.sm.unknown': 'Sconosciuto',
    'pca.sm.typeReply': 'Scrivi qui la tua risposta...',
    'pca.sm.sending': 'Invio in corso...',
    'pca.sm.sendReply': 'Invia risposta',
    'pca.sm.reply': 'Rispondi',
    'pca.sm.replyAgain': 'Rispondi di nuovo',
    'pca.sm.noInquiriesYet': 'Ancora nessuna richiesta dei clienti',
    'pca.sm.customerReviews': 'Recensioni dei clienti',
    'pca.sm.respondFeedback': 'Rispondi ai feedback e alle recensioni dei clienti',
    'pca.sm.responded': 'Risposto',
    'pca.sm.new': 'Nuovo',
    'pca.sm.yourResponse': 'La tua risposta:',
    'pca.sm.respondedOn': 'Risposto il:',
    'pca.sm.thankCustomer': 'Ringrazia il cliente e fornisci la tua risposta...',
    'pca.sm.posting': 'Pubblicazione in corso...',
    'pca.sm.postResponse': 'Pubblica risposta',
    'pca.sm.updateResponse': 'Aggiorna risposta',
    'pca.sm.respond': 'Rispondi',
    'pca.sm.noReviewsYet': 'Ancora nessuna recensione dei clienti',
    'pca.sm.editProduct': 'Modifica prodotto',
    'pca.sm.updateProductInfo': 'Aggiorna le informazioni del prodotto',
    'pca.sm.describeProduct': 'Descrivi il tuo prodotto...',
    'pca.sm.currentImagesReplace': 'Immagini attuali ({count}) — il caricamento di nuove immagini le sostituisce',
    'pca.sm.replaceProductVideo': 'Sostituisci video del prodotto',
    'pca.sm.newVideoUploaded': 'Nuovo video caricato',
    'pca.sm.currentVideo': 'Video attuale',
    'pca.sm.removeVideo': 'Rimuovi video',
    'pca.sm.updateProduct': 'Aggiorna prodotto',

    // ---- CreateSurvey ----
    'pca.survey.surveyDetails': 'Dettagli del sondaggio',
    'pca.survey.surveyTitleReq': 'Titolo del sondaggio *',
    'pca.survey.enterTitle': 'Inserisci il titolo del sondaggio',
    'pca.survey.descriptionReq': 'Descrizione *',
    'pca.survey.describeSurvey': 'Descrivi di cosa tratta questo sondaggio',
    'pca.survey.surveyTypeReq': 'Tipo di sondaggio *',
    'pca.survey.paidSurvey': 'Sondaggio retribuito',
    'pca.survey.unpaidSurvey': 'Sondaggio non retribuito',
    'pca.survey.reward': 'Ricompensa',
    'pca.survey.communityPoints': 'Punti community',
    'pca.survey.duration': 'Durata',
    'pca.survey.durationExample': '5-10 minuti',
    'pca.survey.difficulty': 'Difficoltà',
    'pca.survey.easy': 'Facile',
    'pca.survey.medium': 'Media',
    'pca.survey.advanced': 'Avanzata',
    'pca.survey.deadlineReq': 'Scadenza *',
    'pca.survey.addQuestions': 'Aggiungi domande',
    'pca.survey.questionType': 'Tipo di domanda',
    'pca.survey.questionReq': 'Domanda *',
    'pca.survey.enterYourQuestion': 'Inserisci la tua domanda',
    'pca.survey.options': 'Opzioni',
    'pca.survey.optionN': 'Opzione {n}',
    'pca.survey.addOption': 'Aggiungi opzione',
    'pca.survey.requiredQuestion': 'Domanda obbligatoria',
    'pca.survey.addQuestion': 'Aggiungi domanda',
    'pca.survey.questionsCount': 'Domande ({count})',
    'pca.survey.required': 'Obbligatoria',
    'pca.survey.creatingSurvey': 'Creazione del sondaggio...',
    'pca.survey.preview': 'Anteprima',
    'pca.survey.details': 'Dettagli',
    'pca.survey.audience': 'Pubblico',
    'pca.survey.typeLabel': 'Tipo:',
    'pca.survey.paid': 'Retribuito',
    'pca.survey.unpaid': 'Non retribuito',
    'pca.survey.rewardLabel': 'Ricompensa:',
    'pca.survey.durationLabel': 'Durata:',
    'pca.survey.difficultyLabel': 'Difficoltà:',
    'pca.survey.questionsLabel': 'Domande:',
    'pca.survey.fillToPreview': "Compila i dettagli del sondaggio per vedere l'anteprima",
    'pca.survey.targetAll': 'Target: Tutti i clienti di {business}',
    'pca.survey.yourBusiness': 'la tua azienda',
    'pca.survey.deadlineLabel': 'Scadenza:',
    'pca.survey.requiredQuestions': '{count} domanda/e obbligatoria/e',
    'pca.survey.totalQuestions': '{count} domanda/e aggiunta/e in totale',
    'pca.survey.surveyTips': 'Suggerimenti per il sondaggio',
    'pca.survey.tip1': 'Mantieni le domande chiare e concise',
    'pca.survey.tip2': 'Usa un mix di tipi di domande per aumentare il coinvolgimento',
    'pca.survey.tip3': 'Offri ricompense adeguate alla durata del sondaggio',
    'pca.survey.tip4': 'Testa il tuo sondaggio prima di pubblicarlo',
    'pca.survey.tip5': 'Imposta scadenze realistiche',
  },
  ja: {
    // ---- ShowroomManager ----
    'pca.sm.productPublished': '製品を公開しました',
    'pca.sm.correctionRequested': '修正の依頼',
    'pca.sm.correctionAccepted': '修正が承認されました',
    'pca.sm.showroomRequiredHint': 'Marketplace に商品を追加する前にショールームを作成してください。',
    'pca.sm.correctionAwaitingReview': '修正を送信しました — 審査待ち',
    'pca.sm.correctionRequestedAt': '依頼日',
    'pca.sm.correctionEditHint': 'この掲載を編集して保存してください。',
    'pca.sm.correctionSubmittedHint': '更新を送信しました。Servisfy が確認します。',
    'pca.sm.productHidden': '製品を非表示にしました',
    'pca.sm.productNowActive': '{name} は現在アクティブです。',
    'pca.sm.productNowHidden': '{name} は現在非表示です。',
    'pca.sm.updateFailed': '更新に失敗しました',
    'pca.sm.confirmDeleteProduct': '「{name}」を削除しますか？この操作は元に戻せません。',
    'pca.sm.productDeleted': '製品を削除しました',
    'pca.sm.productWasRemoved': '{name} を削除しました。',
    'pca.sm.deleteFailed': '削除に失敗しました',
    'pca.sm.formError': 'フォームエラー',
    'pca.sm.formNotInit': 'フォームデータが正しく初期化されていません。',
    'pca.sm.validationError': '検証エラー',
    'pca.sm.fillRequiredFields': 'すべての必須項目を入力してください。',
    'pca.sm.authError': '認証エラー',
    'pca.sm.businessIdRequiredLogin': 'ユーザーのビジネスIDが必要です。もう一度ログインしてください。',
    'pca.sm.showroomUpdated': 'ショールームを更新しました',
    'pca.sm.showroomUpdatedDesc': 'ショールームの詳細が正常に更新されました！',
    'pca.sm.showroomCreated': 'ショールームを作成しました',
    'pca.sm.showroomCreatedDesc': 'ショールームが正常に作成されました！',
    'pca.sm.failedSaveShowroom': 'ショールームの保存に失敗しました。もう一度お試しください。',
    'pca.sm.productNameDescRequired': '製品名と説明は必須です。',
    'pca.sm.categoryRequired': 'カテゴリーが必要です',
    'pca.sm.selectCategoryBeforeSaving': '保存する前に製品カテゴリーを選択してください。',
    'pca.sm.functionNotAvailable': '機能を利用できません',
    'pca.sm.productCreateFnUnavailable': '製品作成機能を利用できません。ページを更新してください。',
    'pca.sm.productAddedTitle': '製品を正常に追加しました',
    'pca.sm.productAddedDesc': '{name} がショールームに追加され、製品とサービスに表示されるようになりました。',
    'pca.sm.errorAddingProduct': '製品の追加中にエラーが発生しました',
    'pca.sm.failedAddProduct': '製品を追加できませんでした：{error}',
    'pca.sm.unknownErrorOccurred': '不明なエラーが発生しました',
    'pca.sm.unknownError': '不明なエラー',
    'pca.sm.tooManyImages': '画像が多すぎます',
    'pca.sm.selectUpTo10': '合計で最大10枚まで画像を選択してください。',
    'pca.sm.unsupportedFile': 'サポートされていないファイル',
    'pca.sm.onlyImageTypes': '{name}：JPEG、PNG、WebP画像のみ許可されています。',
    'pca.sm.fileTooLarge': 'ファイルが大きすぎます',
    'pca.sm.imageMaxSize': '{name}：画像は10MB以下である必要があります。',
    'pca.sm.imagesUploaded': '画像をアップロードしました',
    'pca.sm.imagesAdded': '{count}枚の画像を追加しました。',
    'pca.sm.uploadFailed': 'アップロードに失敗しました',
    'pca.sm.couldNotUploadImage': '画像をアップロードできませんでした。',
    'pca.sm.onlyVideoTypes': '{name}：MP4またはMOV動画のみ許可されています。',
    'pca.sm.videoMaxSize': '{name}：動画は100MB以下である必要があります。',
    'pca.sm.videoUploaded': '動画をアップロードしました',
    'pca.sm.productVideoAdded': '製品動画を追加しました。',
    'pca.sm.couldNotUploadVideo': '動画をアップロードできませんでした。',
    'pca.sm.productUpdateFnUnavailable': '製品更新機能を利用できません。ページを更新してください。',
    'pca.sm.productUpdated': '製品を更新しました',
    'pca.sm.productUpdatedDesc': '{name} を正常に更新しました。',
    'pca.sm.errorUpdatingProduct': '製品の更新中にエラーが発生しました',
    'pca.sm.failedUpdateProduct': '製品を更新できませんでした：{error}',
    'pca.sm.imagesUploadedTitle': '画像をアップロードしました',
    'pca.sm.imagesUploadedComingSoon': '{count}枚の画像をアップロードしました。ショールームギャラリーへの添付は近日公開予定です。',
    'pca.sm.uploadFailedTitle': 'アップロードに失敗しました',
    'pca.sm.couldNotUploadImages': '画像をアップロードできませんでした。もう一度お試しください。',
    'pca.sm.showroomNotAvailable': 'ショールームを利用できません',
    'pca.sm.showroomDataNotLoaded': 'ショールームのデータが読み込まれていません。ページを更新してもう一度お試しください。',
    'pca.sm.publicProfilePreview': '公開プロフィールのプレビュー',
    'pca.sm.showingPreview': '公開ショールームプロフィールのプレビューを新しいウィンドウで表示しています。',
    'pca.sm.previewBlocked': 'プレビューがブロックされました',
    'pca.sm.popupBlocked': 'ポップアップがブロックされました。ショールームは公開されており、顧客がアクセスできます。',
    'pca.sm.showroomDataNotAvailable': 'ショールームのデータを利用できません。ページを更新してください。',
    'pca.sm.editModeEnabled': '編集モードが有効になりました',
    'pca.sm.editModeDesc': "ショールームの説明や詳細を更新できるようになりました。完了したら「{action}」をクリックすることを忘れないでください。",
    'pca.sm.replyRequired': '返信が必要です',
    'pca.sm.enterReplyMessage': '返信メッセージを入力してください。',
    'pca.sm.inquiryNotFound': '問い合わせが見つかりません',
    'pca.sm.couldNotFindInquiry': '返信する問い合わせが見つかりませんでした。',
    'pca.sm.replyFnUnavailable': '返信機能を利用できません。ページを更新してください。',
    'pca.sm.businessIdRequiredReplies': '返信を送信するにはビジネスIDが必要です。更新してもう一度お試しください。',
    'pca.sm.replySent': '返信を正常に送信しました',
    'pca.sm.replySentDesc': '{customer} に返信を送信しました。ステータスが「返信済み」に更新されました。ダイアログは3秒後に閉じます。',
    'pca.sm.errorSendingReply': '返信の送信中にエラーが発生しました',
    'pca.sm.failedSendReply': '返信を送信できませんでした：{error}',
    'pca.sm.responseRequired': '回答が必要です',
    'pca.sm.enterResponseMessage': '回答メッセージを入力してください。',
    'pca.sm.reviewNotFound': 'レビューが見つかりません',
    'pca.sm.couldNotFindReview': '回答するレビューが見つかりませんでした。',
    'pca.sm.responseFnUnavailable': '回答機能を利用できません。ページを更新してください。',
    'pca.sm.businessIdRequiredResponses': '回答を投稿するにはビジネスIDが必要です。更新してもう一度お試しください。',
    'pca.sm.responsePosted': '回答を正常に投稿しました',
    'pca.sm.responsePostedDesc': '{customer} への回答を投稿しました。ステータスが「回答済み」に更新されました。ダイアログは3秒後に閉じます。',
    'pca.sm.errorPostingResponse': '回答の投稿中にエラーが発生しました',
    'pca.sm.failedPostResponse': '回答を投稿できませんでした：{error}',
    'pca.sm.addressRequired': '住所が必要です',
    'pca.sm.enterAddressLookup': '場所を検索するには住所を入力してください。',
    'pca.sm.locationFound': '場所が見つかりました',
    'pca.sm.locationVerifiedUpdated': '場所が確認され、更新されました。',
    'pca.sm.locationError': '場所エラー',
    'pca.sm.failedFindLocation': '場所が見つかりませんでした。住所を確認してもう一度お試しください。',
    'pca.sm.creating': '作成中...',
    'pca.sm.chat': 'チャット',
    'pca.sm.inAppCalls': 'アプリ内通話',
    'pca.sm.noAddressProvided': '住所が入力されていません',
    'pca.sm.contactForPrice': '価格はお問い合わせください',
    'pca.sm.productVideoTitle': '製品動画',
    'pca.sm.unpublish': '非公開にする',
    'pca.sm.publish': '公開する',
    'pca.sm.addNewProduct': '新しい製品を追加',
    'pca.sm.addShowroomItem': 'ショールーム項目を追加',
    'pca.sm.editShowroomItem': 'ショールーム項目を編集',
    'pca.sm.updateItemInfo': '項目情報を更新',
    'pca.sm.noItemsYet': '項目はまだありません',
    'pca.sm.addShowroomItemDesc': '公開ショールームにサービスまたは製品を公開します。',
    'pca.sm.itemTypeReq': '項目タイプ *',
    'pca.sm.itemTypeService': 'サービス',
    'pca.sm.itemTypeProduct': '製品',
    'pca.sm.itemNameReq': '項目名 *',
    'pca.sm.serviceNameReq': 'サービス名 *',
    'pca.sm.itemImagesOptional': '画像（任意）',
    'pca.sm.uploadToShowroom': 'ショールームにアップロード',
    'pca.sm.uploadShowroomImages': 'ショールーム画像をアップロード',
    'pca.sm.addPhotosGallery': 'ショールームギャラリーに写真を追加',
    'pca.sm.dragDropImages': 'ここに画像をドラッグ＆ドロップするか、クリックして参照してください',
    'pca.sm.selectFiles': 'ファイルを選択',
    'pca.sm.uploadAndClose': 'アップロードして閉じる',
    'pca.sm.viewPublicProfile': '公開プロフィールを表示',
    'pca.sm.customerInquiries': '顧客の問い合わせ',
    'pca.sm.performanceTips': 'パフォーマンスのヒント',
    'pca.sm.addMoreImages': '画像を追加',
    'pca.sm.images40more': '3枚以上の画像がある製品は40％多く閲覧されます',
    'pca.sm.uploadImages': '画像をアップロード',
    'pca.sm.updateDescriptions': '説明を更新',
    'pca.sm.detailedDescImprove': '詳細な説明は検索での表示を改善します',
    'pca.sm.editDescriptions': '説明を編集',
    'pca.sm.respondToReviews': 'レビューに返信',
    'pca.sm.activeEngagement': '積極的な関与は顧客の信頼を築きます',
    'pca.sm.viewReviews': 'レビューを表示',
    'pca.sm.createNewShowroom': '新しいショールームを作成',
    'pca.sm.quickCreateShowroom': 'ビジネス用のショールームをすばやく作成',
    'pca.sm.create': '作成',
    'pca.sm.addProductDesc': 'ショールームに製品またはサービスを追加',
    'pca.sm.productNameReq': '製品名 *',
    'pca.sm.enterProductName': '製品名を入力',
    'pca.sm.descriptionReq': '説明 *',
    'pca.sm.describeProductService': '製品またはサービスを説明してください',
    'pca.sm.price': '価格',
    'pca.sm.categoryReq': 'カテゴリー *',
    'pca.sm.selectCategory': 'カテゴリーを選択…',
    'pca.sm.productImages': '製品画像',
    'pca.sm.uploading': 'アップロード中…',
    'pca.sm.uploadProductImages': '製品画像をアップロード',
    'pca.sm.upTo10Images': '最大10枚の画像が許可されています',
    'pca.sm.recommendedFormat': '推奨：1200x800px、JPG/PNG形式',
    'pca.sm.imagesUploadedCount': '{count}枚の画像をアップロードしました',
    'pca.sm.productVideo': '製品動画',
    'pca.sm.optional': '（任意）',
    'pca.sm.uploadProductVideo': '製品動画をアップロード',
    'pca.sm.oneVideoPerProduct': '製品ごとに1本の動画',
    'pca.sm.videoFormatMax': 'MP4またはMOV、最大100MB',
    'pca.sm.videoUploadedLabel': '動画をアップロードしました',
    'pca.sm.showroomAnalytics': 'ショールーム分析',
    'pca.sm.detailedMetrics': 'ショールームの詳細なパフォーマンス指標',
    'pca.sm.visitors': '訪問者',
    'pca.sm.inquiries': '問い合わせ',
    'pca.sm.analyticsNotAvailable': 'ショールームの詳細な分析はまだ利用できません。',
    'pca.sm.manageInquiries': '顧客の質問とリクエストを管理',
    'pca.sm.replied': '返信済み',
    'pca.sm.from': '差出人：',
    'pca.sm.yourReply': 'あなたの返信：',
    'pca.sm.repliedOn': '返信日：',
    'pca.sm.unknown': '不明',
    'pca.sm.typeReply': 'ここに返信を入力してください...',
    'pca.sm.sending': '送信中...',
    'pca.sm.sendReply': '返信を送信',
    'pca.sm.reply': '返信',
    'pca.sm.replyAgain': '再度返信',
    'pca.sm.noInquiriesYet': 'まだ顧客の問い合わせはありません',
    'pca.sm.customerReviews': '顧客レビュー',
    'pca.sm.respondFeedback': '顧客のフィードバックやレビューに返信',
    'pca.sm.responded': '回答済み',
    'pca.sm.new': '新規',
    'pca.sm.yourResponse': 'あなたの回答：',
    'pca.sm.respondedOn': '回答日：',
    'pca.sm.thankCustomer': '顧客に感謝し、回答を入力してください...',
    'pca.sm.posting': '投稿中...',
    'pca.sm.postResponse': '回答を投稿',
    'pca.sm.updateResponse': '回答を更新',
    'pca.sm.respond': '回答',
    'pca.sm.noReviewsYet': 'まだ顧客レビューはありません',
    'pca.sm.editProduct': '製品を編集',
    'pca.sm.updateProductInfo': '製品情報を更新',
    'pca.sm.describeProduct': '製品を説明してください...',
    'pca.sm.currentImagesReplace': '現在の画像（{count}）— 新しい画像をアップロードするとこれらが置き換えられます',
    'pca.sm.replaceProductVideo': '製品動画を置き換える',
    'pca.sm.newVideoUploaded': '新しい動画をアップロードしました',
    'pca.sm.currentVideo': '現在の動画',
    'pca.sm.removeVideo': '動画を削除',
    'pca.sm.updateProduct': '製品を更新',

    // ---- CreateSurvey ----
    'pca.survey.surveyDetails': 'アンケートの詳細',
    'pca.survey.surveyTitleReq': 'アンケートのタイトル *',
    'pca.survey.enterTitle': 'アンケートのタイトルを入力',
    'pca.survey.descriptionReq': '説明 *',
    'pca.survey.describeSurvey': 'このアンケートの内容を説明してください',
    'pca.survey.surveyTypeReq': 'アンケートの種類 *',
    'pca.survey.paidSurvey': '有償アンケート',
    'pca.survey.unpaidSurvey': '無償アンケート',
    'pca.survey.reward': '報酬',
    'pca.survey.communityPoints': 'コミュニティポイント',
    'pca.survey.duration': '所要時間',
    'pca.survey.durationExample': '5〜10分',
    'pca.survey.difficulty': '難易度',
    'pca.survey.easy': '簡単',
    'pca.survey.medium': '普通',
    'pca.survey.advanced': '上級',
    'pca.survey.deadlineReq': '締め切り *',
    'pca.survey.addQuestions': '質問を追加',
    'pca.survey.questionType': '質問の種類',
    'pca.survey.questionReq': '質問 *',
    'pca.survey.enterYourQuestion': '質問を入力してください',
    'pca.survey.options': '選択肢',
    'pca.survey.optionN': '選択肢 {n}',
    'pca.survey.addOption': '選択肢を追加',
    'pca.survey.requiredQuestion': '必須の質問',
    'pca.survey.addQuestion': '質問を追加',
    'pca.survey.questionsCount': '質問（{count}）',
    'pca.survey.required': '必須',
    'pca.survey.creatingSurvey': 'アンケートを作成中...',
    'pca.survey.preview': 'プレビュー',
    'pca.survey.details': '詳細',
    'pca.survey.audience': '対象者',
    'pca.survey.typeLabel': '種類：',
    'pca.survey.paid': '有償',
    'pca.survey.unpaid': '無償',
    'pca.survey.rewardLabel': '報酬：',
    'pca.survey.durationLabel': '所要時間：',
    'pca.survey.difficultyLabel': '難易度：',
    'pca.survey.questionsLabel': '質問：',
    'pca.survey.fillToPreview': 'アンケートの詳細を入力するとプレビューが表示されます',
    'pca.survey.targetAll': '対象：{business} のすべての顧客',
    'pca.survey.yourBusiness': 'あなたのビジネス',
    'pca.survey.deadlineLabel': '締め切り：',
    'pca.survey.requiredQuestions': '必須の質問 {count} 件',
    'pca.survey.totalQuestions': '追加された質問は合計 {count} 件',
    'pca.survey.surveyTips': 'アンケートのヒント',
    'pca.survey.tip1': '質問は明確で簡潔にしましょう',
    'pca.survey.tip2': 'エンゲージメントを高めるためにさまざまな種類の質問を使いましょう',
    'pca.survey.tip3': 'アンケートの長さに応じた適切な報酬を提供しましょう',
    'pca.survey.tip4': '公開する前にアンケートをテストしましょう',
    'pca.survey.tip5': '現実的な締め切りを設定しましょう',
  },
  ko: {
    // ---- ShowroomManager ----
    'pca.sm.productPublished': '제품이 게시되었습니다',
    'pca.sm.correctionRequested': '수정 요청됨',
    'pca.sm.correctionAccepted': '수정이 승인됨',
    'pca.sm.showroomRequiredHint': 'Marketplace 항목을 추가하기 전에 쇼룸을 만드세요.',
    'pca.sm.correctionAwaitingReview': '수정 제출됨 — 검토 대기',
    'pca.sm.correctionRequestedAt': '요청일',
    'pca.sm.correctionEditHint': '요청에 맞게 목록을 수정한 후 저장하세요.',
    'pca.sm.correctionSubmittedHint': '업데이트가 제출되었습니다. Servisfy가 검토합니다.',
    'pca.sm.productHidden': '제품이 숨겨졌습니다',
    'pca.sm.productNowActive': '{name}이(가) 이제 활성화되었습니다.',
    'pca.sm.productNowHidden': '{name}이(가) 이제 숨겨졌습니다.',
    'pca.sm.updateFailed': '업데이트 실패',
    'pca.sm.confirmDeleteProduct': '"{name}"을(를) 삭제하시겠습니까? 이 작업은 되돌릴 수 없습니다.',
    'pca.sm.productDeleted': '제품이 삭제되었습니다',
    'pca.sm.productWasRemoved': '{name}이(가) 삭제되었습니다.',
    'pca.sm.deleteFailed': '삭제 실패',
    'pca.sm.formError': '양식 오류',
    'pca.sm.formNotInit': '양식 데이터가 올바르게 초기화되지 않았습니다.',
    'pca.sm.validationError': '유효성 검사 오류',
    'pca.sm.fillRequiredFields': '모든 필수 항목을 입력해 주세요.',
    'pca.sm.authError': '인증 오류',
    'pca.sm.businessIdRequiredLogin': '사용자의 비즈니스 ID가 필요합니다. 다시 로그인해 주세요.',
    'pca.sm.showroomUpdated': '쇼룸이 업데이트되었습니다',
    'pca.sm.showroomUpdatedDesc': '쇼룸 세부 정보가 성공적으로 업데이트되었습니다!',
    'pca.sm.showroomCreated': '쇼룸이 생성되었습니다',
    'pca.sm.showroomCreatedDesc': '쇼룸이 성공적으로 생성되었습니다!',
    'pca.sm.failedSaveShowroom': '쇼룸을 저장하지 못했습니다. 다시 시도해 주세요.',
    'pca.sm.productNameDescRequired': '제품 이름과 설명은 필수입니다.',
    'pca.sm.categoryRequired': '카테고리 필요',
    'pca.sm.selectCategoryBeforeSaving': '저장하기 전에 제품 카테고리를 선택해 주세요.',
    'pca.sm.functionNotAvailable': '기능을 사용할 수 없습니다',
    'pca.sm.productCreateFnUnavailable': '제품 생성 기능을 사용할 수 없습니다. 페이지를 새로고침해 주세요.',
    'pca.sm.productAddedTitle': '제품이 성공적으로 추가되었습니다',
    'pca.sm.productAddedDesc': '{name}이(가) 쇼룸에 추가되었으며 이제 제품 및 서비스에 표시됩니다.',
    'pca.sm.errorAddingProduct': '제품 추가 중 오류',
    'pca.sm.failedAddProduct': '제품을 추가하지 못했습니다: {error}',
    'pca.sm.unknownErrorOccurred': '알 수 없는 오류가 발생했습니다',
    'pca.sm.unknownError': '알 수 없는 오류',
    'pca.sm.tooManyImages': '이미지가 너무 많습니다',
    'pca.sm.selectUpTo10': '총 최대 10개의 이미지를 선택해 주세요.',
    'pca.sm.unsupportedFile': '지원되지 않는 파일',
    'pca.sm.onlyImageTypes': '{name}: JPEG, PNG 또는 WebP 이미지만 허용됩니다.',
    'pca.sm.fileTooLarge': '파일이 너무 큽니다',
    'pca.sm.imageMaxSize': '{name}: 이미지는 10MB 이하여야 합니다.',
    'pca.sm.imagesUploaded': '이미지가 업로드되었습니다',
    'pca.sm.imagesAdded': '{count}개의 이미지가 추가되었습니다.',
    'pca.sm.uploadFailed': '업로드 실패',
    'pca.sm.couldNotUploadImage': '이미지를 업로드할 수 없습니다.',
    'pca.sm.onlyVideoTypes': '{name}: MP4 또는 MOV 동영상만 허용됩니다.',
    'pca.sm.videoMaxSize': '{name}: 동영상은 100MB 이하여야 합니다.',
    'pca.sm.videoUploaded': '동영상이 업로드되었습니다',
    'pca.sm.productVideoAdded': '제품 동영상이 추가되었습니다.',
    'pca.sm.couldNotUploadVideo': '동영상을 업로드할 수 없습니다.',
    'pca.sm.productUpdateFnUnavailable': '제품 업데이트 기능을 사용할 수 없습니다. 페이지를 새로고침해 주세요.',
    'pca.sm.productUpdated': '제품이 업데이트되었습니다',
    'pca.sm.productUpdatedDesc': '{name}이(가) 성공적으로 업데이트되었습니다.',
    'pca.sm.errorUpdatingProduct': '제품 업데이트 중 오류',
    'pca.sm.failedUpdateProduct': '제품을 업데이트하지 못했습니다: {error}',
    'pca.sm.imagesUploadedTitle': '이미지가 업로드되었습니다',
    'pca.sm.imagesUploadedComingSoon': '{count}개의 이미지가 업로드되었습니다. 쇼룸 갤러리 첨부 기능은 곧 제공됩니다.',
    'pca.sm.uploadFailedTitle': '업로드 실패',
    'pca.sm.couldNotUploadImages': '이미지를 업로드할 수 없습니다. 다시 시도해 주세요.',
    'pca.sm.showroomNotAvailable': '쇼룸을 사용할 수 없습니다',
    'pca.sm.showroomDataNotLoaded': '쇼룸 데이터가 로드되지 않았습니다. 페이지를 새로고침한 후 다시 시도해 주세요.',
    'pca.sm.publicProfilePreview': '공개 프로필 미리보기',
    'pca.sm.showingPreview': '공개 쇼룸 프로필 미리보기를 새 창에 표시하고 있습니다.',
    'pca.sm.previewBlocked': '미리보기가 차단되었습니다',
    'pca.sm.popupBlocked': '팝업이 차단되었습니다. 쇼룸은 활성 상태이며 고객이 접근할 수 있습니다.',
    'pca.sm.showroomDataNotAvailable': '쇼룸 데이터를 사용할 수 없습니다. 페이지를 새로고침해 주세요.',
    'pca.sm.editModeEnabled': '편집 모드가 활성화되었습니다',
    'pca.sm.editModeDesc': "이제 쇼룸 설명과 세부 정보를 업데이트할 수 있습니다. 완료 후 '{action}'을(를) 클릭하는 것을 잊지 마세요.",
    'pca.sm.replyRequired': '답장 필요',
    'pca.sm.enterReplyMessage': '답장 메시지를 입력해 주세요.',
    'pca.sm.inquiryNotFound': '문의를 찾을 수 없습니다',
    'pca.sm.couldNotFindInquiry': '답장할 문의를 찾을 수 없습니다.',
    'pca.sm.replyFnUnavailable': '답장 기능을 사용할 수 없습니다. 페이지를 새로고침해 주세요.',
    'pca.sm.businessIdRequiredReplies': '답장을 보내려면 비즈니스 ID가 필요합니다. 새로고침한 후 다시 시도해 주세요.',
    'pca.sm.replySent': '답장이 성공적으로 전송되었습니다',
    'pca.sm.replySentDesc': '{customer}에게 답장이 전송되었습니다. 상태가 "답장함"으로 업데이트되었습니다. 대화 상자는 3초 후에 닫힙니다.',
    'pca.sm.errorSendingReply': '답장 전송 중 오류',
    'pca.sm.failedSendReply': '답장을 보내지 못했습니다: {error}',
    'pca.sm.responseRequired': '응답 필요',
    'pca.sm.enterResponseMessage': '응답 메시지를 입력해 주세요.',
    'pca.sm.reviewNotFound': '리뷰를 찾을 수 없습니다',
    'pca.sm.couldNotFindReview': '응답할 리뷰를 찾을 수 없습니다.',
    'pca.sm.responseFnUnavailable': '응답 기능을 사용할 수 없습니다. 페이지를 새로고침해 주세요.',
    'pca.sm.businessIdRequiredResponses': '응답을 게시하려면 비즈니스 ID가 필요합니다. 새로고침한 후 다시 시도해 주세요.',
    'pca.sm.responsePosted': '응답이 성공적으로 게시되었습니다',
    'pca.sm.responsePostedDesc': '{customer}에 대한 응답이 게시되었습니다. 상태가 "응답함"으로 업데이트되었습니다. 대화 상자는 3초 후에 닫힙니다.',
    'pca.sm.errorPostingResponse': '응답 게시 중 오류',
    'pca.sm.failedPostResponse': '응답을 게시하지 못했습니다: {error}',
    'pca.sm.addressRequired': '주소 필요',
    'pca.sm.enterAddressLookup': '위치를 검색하려면 주소를 입력해 주세요.',
    'pca.sm.locationFound': '위치를 찾았습니다',
    'pca.sm.locationVerifiedUpdated': '위치가 확인되고 업데이트되었습니다.',
    'pca.sm.locationError': '위치 오류',
    'pca.sm.failedFindLocation': '위치를 찾을 수 없습니다. 주소를 확인한 후 다시 시도해 주세요.',
    'pca.sm.creating': '생성 중...',
    'pca.sm.chat': '채팅',
    'pca.sm.inAppCalls': '앱 내 통화',
    'pca.sm.noAddressProvided': '주소가 제공되지 않았습니다',
    'pca.sm.contactForPrice': '가격 문의',
    'pca.sm.productVideoTitle': '제품 동영상',
    'pca.sm.unpublish': '게시 취소',
    'pca.sm.publish': '게시',
    'pca.sm.addNewProduct': '새 제품 추가',
    'pca.sm.addShowroomItem': '쇼룸 항목 추가',
    'pca.sm.editShowroomItem': '쇼룸 항목 편집',
    'pca.sm.updateItemInfo': '항목 정보 업데이트',
    'pca.sm.noItemsYet': '항목이 아직 없습니다',
    'pca.sm.addShowroomItemDesc': '공개 쇼룸에 서비스 또는 제품을 게시합니다.',
    'pca.sm.itemTypeReq': '항목 유형 *',
    'pca.sm.itemTypeService': '서비스',
    'pca.sm.itemTypeProduct': '제품',
    'pca.sm.itemNameReq': '항목 이름 *',
    'pca.sm.serviceNameReq': '서비스 이름 *',
    'pca.sm.itemImagesOptional': '이미지(선택)',
    'pca.sm.uploadToShowroom': '쇼룸에 업로드',
    'pca.sm.uploadShowroomImages': '쇼룸 이미지 업로드',
    'pca.sm.addPhotosGallery': '쇼룸 갤러리에 사진 추가',
    'pca.sm.dragDropImages': '여기에 이미지를 끌어다 놓거나 클릭하여 찾아보세요',
    'pca.sm.selectFiles': '파일 선택',
    'pca.sm.uploadAndClose': '업로드하고 닫기',
    'pca.sm.viewPublicProfile': '공개 프로필 보기',
    'pca.sm.customerInquiries': '고객 문의',
    'pca.sm.performanceTips': '성과 팁',
    'pca.sm.addMoreImages': '이미지 더 추가',
    'pca.sm.images40more': '이미지가 3개 이상인 제품은 조회수가 40% 더 많습니다',
    'pca.sm.uploadImages': '이미지 업로드',
    'pca.sm.updateDescriptions': '설명 업데이트',
    'pca.sm.detailedDescImprove': '자세한 설명은 검색 노출을 개선합니다',
    'pca.sm.editDescriptions': '설명 편집',
    'pca.sm.respondToReviews': '리뷰에 응답',
    'pca.sm.activeEngagement': '적극적인 참여는 고객 신뢰를 구축합니다',
    'pca.sm.viewReviews': '리뷰 보기',
    'pca.sm.createNewShowroom': '새 쇼룸 만들기',
    'pca.sm.quickCreateShowroom': '비즈니스를 위한 쇼룸을 빠르게 만드세요',
    'pca.sm.create': '만들기',
    'pca.sm.addProductDesc': '쇼룸에 제품 또는 서비스 추가',
    'pca.sm.productNameReq': '제품 이름 *',
    'pca.sm.enterProductName': '제품 이름 입력',
    'pca.sm.descriptionReq': '설명 *',
    'pca.sm.describeProductService': '제품 또는 서비스를 설명해 주세요',
    'pca.sm.price': '가격',
    'pca.sm.categoryReq': '카테고리 *',
    'pca.sm.selectCategory': '카테고리 선택…',
    'pca.sm.productImages': '제품 이미지',
    'pca.sm.uploading': '업로드 중…',
    'pca.sm.uploadProductImages': '제품 이미지 업로드',
    'pca.sm.upTo10Images': '최대 10개의 이미지가 허용됩니다',
    'pca.sm.recommendedFormat': '권장: 1200x800px, JPG/PNG 형식',
    'pca.sm.imagesUploadedCount': '{count}개의 이미지가 업로드되었습니다',
    'pca.sm.productVideo': '제품 동영상',
    'pca.sm.optional': '(선택 사항)',
    'pca.sm.uploadProductVideo': '제품 동영상 업로드',
    'pca.sm.oneVideoPerProduct': '제품당 동영상 1개',
    'pca.sm.videoFormatMax': 'MP4 또는 MOV, 최대 100MB',
    'pca.sm.videoUploadedLabel': '동영상이 업로드되었습니다',
    'pca.sm.showroomAnalytics': '쇼룸 분석',
    'pca.sm.detailedMetrics': '쇼룸에 대한 상세한 성과 지표',
    'pca.sm.visitors': '방문자',
    'pca.sm.inquiries': '문의',
    'pca.sm.analyticsNotAvailable': '쇼룸에 대한 상세 분석은 아직 제공되지 않습니다.',
    'pca.sm.manageInquiries': '고객 질문 및 요청 관리',
    'pca.sm.replied': '답장함',
    'pca.sm.from': '보낸 사람:',
    'pca.sm.yourReply': '내 답장:',
    'pca.sm.repliedOn': '답장한 날짜:',
    'pca.sm.unknown': '알 수 없음',
    'pca.sm.typeReply': '여기에 답장을 입력하세요...',
    'pca.sm.sending': '전송 중...',
    'pca.sm.sendReply': '답장 보내기',
    'pca.sm.reply': '답장',
    'pca.sm.replyAgain': '다시 답장',
    'pca.sm.noInquiriesYet': '아직 고객 문의가 없습니다',
    'pca.sm.customerReviews': '고객 리뷰',
    'pca.sm.respondFeedback': '고객 피드백 및 리뷰에 응답',
    'pca.sm.responded': '응답함',
    'pca.sm.new': '신규',
    'pca.sm.yourResponse': '내 응답:',
    'pca.sm.respondedOn': '응답한 날짜:',
    'pca.sm.thankCustomer': '고객에게 감사를 표하고 응답을 입력하세요...',
    'pca.sm.posting': '게시 중...',
    'pca.sm.postResponse': '응답 게시',
    'pca.sm.updateResponse': '응답 업데이트',
    'pca.sm.respond': '응답',
    'pca.sm.noReviewsYet': '아직 고객 리뷰가 없습니다',
    'pca.sm.editProduct': '제품 편집',
    'pca.sm.updateProductInfo': '제품 정보 업데이트',
    'pca.sm.describeProduct': '제품을 설명해 주세요...',
    'pca.sm.currentImagesReplace': '현재 이미지 ({count}) — 새 이미지를 업로드하면 이 이미지들이 대체됩니다',
    'pca.sm.replaceProductVideo': '제품 동영상 교체',
    'pca.sm.newVideoUploaded': '새 동영상이 업로드되었습니다',
    'pca.sm.currentVideo': '현재 동영상',
    'pca.sm.removeVideo': '동영상 제거',
    'pca.sm.updateProduct': '제품 업데이트',

    // ---- CreateSurvey ----
    'pca.survey.surveyDetails': '설문조사 세부 정보',
    'pca.survey.surveyTitleReq': '설문조사 제목 *',
    'pca.survey.enterTitle': '설문조사 제목 입력',
    'pca.survey.descriptionReq': '설명 *',
    'pca.survey.describeSurvey': '이 설문조사의 내용을 설명해 주세요',
    'pca.survey.surveyTypeReq': '설문조사 유형 *',
    'pca.survey.paidSurvey': '유료 설문조사',
    'pca.survey.unpaidSurvey': '무료 설문조사',
    'pca.survey.reward': '보상',
    'pca.survey.communityPoints': '커뮤니티 포인트',
    'pca.survey.duration': '소요 시간',
    'pca.survey.durationExample': '5~10분',
    'pca.survey.difficulty': '난이도',
    'pca.survey.easy': '쉬움',
    'pca.survey.medium': '보통',
    'pca.survey.advanced': '고급',
    'pca.survey.deadlineReq': '마감일 *',
    'pca.survey.addQuestions': '질문 추가',
    'pca.survey.questionType': '질문 유형',
    'pca.survey.questionReq': '질문 *',
    'pca.survey.enterYourQuestion': '질문을 입력하세요',
    'pca.survey.options': '선택지',
    'pca.survey.optionN': '선택지 {n}',
    'pca.survey.addOption': '선택지 추가',
    'pca.survey.requiredQuestion': '필수 질문',
    'pca.survey.addQuestion': '질문 추가',
    'pca.survey.questionsCount': '질문 ({count})',
    'pca.survey.required': '필수',
    'pca.survey.creatingSurvey': '설문조사 생성 중...',
    'pca.survey.preview': '미리보기',
    'pca.survey.details': '세부 정보',
    'pca.survey.audience': '대상',
    'pca.survey.typeLabel': '유형:',
    'pca.survey.paid': '유료',
    'pca.survey.unpaid': '무료',
    'pca.survey.rewardLabel': '보상:',
    'pca.survey.durationLabel': '소요 시간:',
    'pca.survey.difficultyLabel': '난이도:',
    'pca.survey.questionsLabel': '질문:',
    'pca.survey.fillToPreview': '설문조사 세부 정보를 입력하면 미리보기가 표시됩니다',
    'pca.survey.targetAll': '대상: {business}의 모든 고객',
    'pca.survey.yourBusiness': '귀하의 비즈니스',
    'pca.survey.deadlineLabel': '마감일:',
    'pca.survey.requiredQuestions': '필수 질문 {count}개',
    'pca.survey.totalQuestions': '추가된 질문 총 {count}개',
    'pca.survey.surveyTips': '설문조사 팁',
    'pca.survey.tip1': '질문을 명확하고 간결하게 유지하세요',
    'pca.survey.tip2': '참여도를 높이기 위해 다양한 질문 유형을 사용하세요',
    'pca.survey.tip3': '설문조사 길이에 맞는 적절한 보상을 제공하세요',
    'pca.survey.tip4': '게시하기 전에 설문조사를 테스트하세요',
    'pca.survey.tip5': '현실적인 마감일을 설정하세요',
  },
  zh: {
    // ---- ShowroomManager ----
    'pca.sm.productPublished': '产品已发布',
    'pca.sm.correctionRequested': '请求修正',
    'pca.sm.correctionAccepted': '修正已接受',
    'pca.sm.showroomRequiredHint': '添加 Marketplace 项目前请先创建您的展厅。',
    'pca.sm.correctionAwaitingReview': '修正已提交 — 等待审核',
    'pca.sm.correctionRequestedAt': '请求于',
    'pca.sm.correctionEditHint': '请编辑此条目以回应请求，然后保存。',
    'pca.sm.correctionSubmittedHint': '您的更新已提交，Servisfy 将进行审核。',
    'pca.sm.productHidden': '产品已隐藏',
    'pca.sm.productNowActive': '{name} 现已激活。',
    'pca.sm.productNowHidden': '{name} 现已隐藏。',
    'pca.sm.updateFailed': '更新失败',
    'pca.sm.confirmDeleteProduct': '删除“{name}”？此操作无法撤销。',
    'pca.sm.productDeleted': '产品已删除',
    'pca.sm.productWasRemoved': '{name} 已被删除。',
    'pca.sm.deleteFailed': '删除失败',
    'pca.sm.formError': '表单错误',
    'pca.sm.formNotInit': '表单数据未正确初始化。',
    'pca.sm.validationError': '验证错误',
    'pca.sm.fillRequiredFields': '请填写所有必填字段。',
    'pca.sm.authError': '身份验证错误',
    'pca.sm.businessIdRequiredLogin': '需要用户的商家 ID。请重新登录。',
    'pca.sm.showroomUpdated': '展厅已更新',
    'pca.sm.showroomUpdatedDesc': '您的展厅详情已成功更新！',
    'pca.sm.showroomCreated': '展厅已创建',
    'pca.sm.showroomCreatedDesc': '您的展厅已成功创建！',
    'pca.sm.failedSaveShowroom': '无法保存展厅。请重试。',
    'pca.sm.productNameDescRequired': '产品名称和描述为必填项。',
    'pca.sm.categoryRequired': '需要类别',
    'pca.sm.selectCategoryBeforeSaving': '请在保存前选择产品类别。',
    'pca.sm.functionNotAvailable': '功能不可用',
    'pca.sm.productCreateFnUnavailable': '产品创建功能不可用。请刷新页面。',
    'pca.sm.productAddedTitle': '产品添加成功',
    'pca.sm.productAddedDesc': '{name} 已添加到您的展厅，现已显示在“产品与服务”中。',
    'pca.sm.errorAddingProduct': '添加产品时出错',
    'pca.sm.failedAddProduct': '无法添加产品：{error}',
    'pca.sm.unknownErrorOccurred': '发生未知错误',
    'pca.sm.unknownError': '未知错误',
    'pca.sm.tooManyImages': '图片过多',
    'pca.sm.selectUpTo10': '请最多选择 10 张图片。',
    'pca.sm.unsupportedFile': '不支持的文件',
    'pca.sm.onlyImageTypes': '{name}：仅允许 JPEG、PNG 或 WebP 图片。',
    'pca.sm.fileTooLarge': '文件过大',
    'pca.sm.imageMaxSize': '{name}：图片必须为 10MB 或更小。',
    'pca.sm.imagesUploaded': '图片已上传',
    'pca.sm.imagesAdded': '已添加 {count} 张图片。',
    'pca.sm.uploadFailed': '上传失败',
    'pca.sm.couldNotUploadImage': '无法上传图片。',
    'pca.sm.onlyVideoTypes': '{name}：仅允许 MP4 或 MOV 视频。',
    'pca.sm.videoMaxSize': '{name}：视频必须为 100MB 或更小。',
    'pca.sm.videoUploaded': '视频已上传',
    'pca.sm.productVideoAdded': '产品视频已添加。',
    'pca.sm.couldNotUploadVideo': '无法上传视频。',
    'pca.sm.productUpdateFnUnavailable': '产品更新功能不可用。请刷新页面。',
    'pca.sm.productUpdated': '产品已更新',
    'pca.sm.productUpdatedDesc': '{name} 已成功更新。',
    'pca.sm.errorUpdatingProduct': '更新产品时出错',
    'pca.sm.failedUpdateProduct': '无法更新产品：{error}',
    'pca.sm.imagesUploadedTitle': '图片已上传',
    'pca.sm.imagesUploadedComingSoon': '已上传 {count} 张图片。展厅图库附件功能即将推出。',
    'pca.sm.uploadFailedTitle': '上传失败',
    'pca.sm.couldNotUploadImages': '无法上传图片。请重试。',
    'pca.sm.showroomNotAvailable': '展厅不可用',
    'pca.sm.showroomDataNotLoaded': '展厅数据未加载。请刷新页面后重试。',
    'pca.sm.publicProfilePreview': '公开资料预览',
    'pca.sm.showingPreview': '正在新窗口中显示您的展厅公开资料预览。',
    'pca.sm.previewBlocked': '预览被阻止',
    'pca.sm.popupBlocked': '弹出窗口被阻止。您的展厅已上线，客户可以访问。',
    'pca.sm.showroomDataNotAvailable': '展厅数据不可用。请刷新页面。',
    'pca.sm.editModeEnabled': '编辑模式已启用',
    'pca.sm.editModeDesc': "您现在可以更新展厅的描述和详情。完成后别忘了点击“{action}”。",
    'pca.sm.replyRequired': '需要回复',
    'pca.sm.enterReplyMessage': '请输入回复消息。',
    'pca.sm.inquiryNotFound': '未找到咨询',
    'pca.sm.couldNotFindInquiry': '找不到要回复的咨询。',
    'pca.sm.replyFnUnavailable': '回复功能不可用。请刷新页面。',
    'pca.sm.businessIdRequiredReplies': '发送回复需要商家 ID。请刷新后重试。',
    'pca.sm.replySent': '回复发送成功',
    'pca.sm.replySentDesc': '您的回复已发送给 {customer}。状态已更新为“已回复”。对话框将在 3 秒后关闭。',
    'pca.sm.errorSendingReply': '发送回复时出错',
    'pca.sm.failedSendReply': '无法发送回复：{error}',
    'pca.sm.responseRequired': '需要回应',
    'pca.sm.enterResponseMessage': '请输入回应消息。',
    'pca.sm.reviewNotFound': '未找到评价',
    'pca.sm.couldNotFindReview': '找不到要回应的评价。',
    'pca.sm.responseFnUnavailable': '回应功能不可用。请刷新页面。',
    'pca.sm.businessIdRequiredResponses': '发布回应需要商家 ID。请刷新后重试。',
    'pca.sm.responsePosted': '回应发布成功',
    'pca.sm.responsePostedDesc': '您对 {customer} 的回应已发布。状态已更新为“已回应”。对话框将在 3 秒后关闭。',
    'pca.sm.errorPostingResponse': '发布回应时出错',
    'pca.sm.failedPostResponse': '无法发布回应：{error}',
    'pca.sm.addressRequired': '需要地址',
    'pca.sm.enterAddressLookup': '请输入地址以查找位置。',
    'pca.sm.locationFound': '已找到位置',
    'pca.sm.locationVerifiedUpdated': '位置已验证并更新。',
    'pca.sm.locationError': '位置错误',
    'pca.sm.failedFindLocation': '无法找到位置。请检查地址后重试。',
    'pca.sm.creating': '正在创建...',
    'pca.sm.chat': '聊天',
    'pca.sm.inAppCalls': '应用内通话',
    'pca.sm.noAddressProvided': '未提供地址',
    'pca.sm.contactForPrice': '价格请咨询',
    'pca.sm.productVideoTitle': '产品视频',
    'pca.sm.unpublish': '取消发布',
    'pca.sm.publish': '发布',
    'pca.sm.addNewProduct': '添加新产品',
    'pca.sm.addShowroomItem': '添加展厅项目',
    'pca.sm.editShowroomItem': '编辑展厅项目',
    'pca.sm.updateItemInfo': '更新项目信息',
    'pca.sm.noItemsYet': '暂无项目',
    'pca.sm.addShowroomItemDesc': '在您的公开展厅中发布服务或产品。',
    'pca.sm.itemTypeReq': '项目类型 *',
    'pca.sm.itemTypeService': '服务',
    'pca.sm.itemTypeProduct': '产品',
    'pca.sm.itemNameReq': '项目名称 *',
    'pca.sm.serviceNameReq': '服务名称 *',
    'pca.sm.itemImagesOptional': '图片（可选）',
    'pca.sm.uploadToShowroom': '上传到展厅',
    'pca.sm.uploadShowroomImages': '上传展厅图片',
    'pca.sm.addPhotosGallery': '向您的展厅图库添加照片',
    'pca.sm.dragDropImages': '将图片拖放到此处，或点击浏览',
    'pca.sm.selectFiles': '选择文件',
    'pca.sm.uploadAndClose': '上传并关闭',
    'pca.sm.viewPublicProfile': '查看公开资料',
    'pca.sm.customerInquiries': '客户咨询',
    'pca.sm.performanceTips': '效果提示',
    'pca.sm.addMoreImages': '添加更多图片',
    'pca.sm.images40more': '拥有 3 张以上图片的产品浏览量增加 40%',
    'pca.sm.uploadImages': '上传图片',
    'pca.sm.updateDescriptions': '更新描述',
    'pca.sm.detailedDescImprove': '详细的描述可提高搜索可见性',
    'pca.sm.editDescriptions': '编辑描述',
    'pca.sm.respondToReviews': '回应评价',
    'pca.sm.activeEngagement': '积极互动可建立客户信任',
    'pca.sm.viewReviews': '查看评价',
    'pca.sm.createNewShowroom': '创建新展厅',
    'pca.sm.quickCreateShowroom': '快速为您的商家创建展厅',
    'pca.sm.create': '创建',
    'pca.sm.addProductDesc': '向您的展厅添加产品或服务',
    'pca.sm.productNameReq': '产品名称 *',
    'pca.sm.enterProductName': '输入产品名称',
    'pca.sm.descriptionReq': '描述 *',
    'pca.sm.describeProductService': '描述您的产品或服务',
    'pca.sm.price': '价格',
    'pca.sm.categoryReq': '类别 *',
    'pca.sm.selectCategory': '选择类别…',
    'pca.sm.productImages': '产品图片',
    'pca.sm.uploading': '正在上传…',
    'pca.sm.uploadProductImages': '上传产品图片',
    'pca.sm.upTo10Images': '最多允许 10 张图片',
    'pca.sm.recommendedFormat': '推荐：1200x800px，JPG/PNG 格式',
    'pca.sm.imagesUploadedCount': '已上传 {count} 张图片',
    'pca.sm.productVideo': '产品视频',
    'pca.sm.optional': '（可选）',
    'pca.sm.uploadProductVideo': '上传产品视频',
    'pca.sm.oneVideoPerProduct': '每个产品一个视频',
    'pca.sm.videoFormatMax': 'MP4 或 MOV，最大 100MB',
    'pca.sm.videoUploadedLabel': '视频已上传',
    'pca.sm.showroomAnalytics': '展厅分析',
    'pca.sm.detailedMetrics': '您展厅的详细效果指标',
    'pca.sm.visitors': '访客',
    'pca.sm.inquiries': '咨询',
    'pca.sm.analyticsNotAvailable': '展厅的详细分析尚不可用。',
    'pca.sm.manageInquiries': '管理客户问题和请求',
    'pca.sm.replied': '已回复',
    'pca.sm.from': '来自：',
    'pca.sm.yourReply': '您的回复：',
    'pca.sm.repliedOn': '回复于：',
    'pca.sm.unknown': '未知',
    'pca.sm.typeReply': '在此输入您的回复...',
    'pca.sm.sending': '正在发送...',
    'pca.sm.sendReply': '发送回复',
    'pca.sm.reply': '回复',
    'pca.sm.replyAgain': '再次回复',
    'pca.sm.noInquiriesYet': '暂无客户咨询',
    'pca.sm.customerReviews': '客户评价',
    'pca.sm.respondFeedback': '回应客户反馈和评价',
    'pca.sm.responded': '已回应',
    'pca.sm.new': '新',
    'pca.sm.yourResponse': '您的回应：',
    'pca.sm.respondedOn': '回应于：',
    'pca.sm.thankCustomer': '感谢客户并提供您的回应...',
    'pca.sm.posting': '正在发布...',
    'pca.sm.postResponse': '发布回应',
    'pca.sm.updateResponse': '更新回应',
    'pca.sm.respond': '回应',
    'pca.sm.noReviewsYet': '暂无客户评价',
    'pca.sm.editProduct': '编辑产品',
    'pca.sm.updateProductInfo': '更新产品信息',
    'pca.sm.describeProduct': '描述您的产品...',
    'pca.sm.currentImagesReplace': '当前图片（{count}）— 上传新图片将替换这些图片',
    'pca.sm.replaceProductVideo': '替换产品视频',
    'pca.sm.newVideoUploaded': '新视频已上传',
    'pca.sm.currentVideo': '当前视频',
    'pca.sm.removeVideo': '移除视频',
    'pca.sm.updateProduct': '更新产品',

    // ---- CreateSurvey ----
    'pca.survey.surveyDetails': '调查详情',
    'pca.survey.surveyTitleReq': '调查标题 *',
    'pca.survey.enterTitle': '输入调查标题',
    'pca.survey.descriptionReq': '描述 *',
    'pca.survey.describeSurvey': '描述此调查的内容',
    'pca.survey.surveyTypeReq': '调查类型 *',
    'pca.survey.paidSurvey': '付费调查',
    'pca.survey.unpaidSurvey': '免费调查',
    'pca.survey.reward': '奖励',
    'pca.survey.communityPoints': '社区积分',
    'pca.survey.duration': '时长',
    'pca.survey.durationExample': '5-10 分钟',
    'pca.survey.difficulty': '难度',
    'pca.survey.easy': '简单',
    'pca.survey.medium': '中等',
    'pca.survey.advanced': '高级',
    'pca.survey.deadlineReq': '截止日期 *',
    'pca.survey.addQuestions': '添加问题',
    'pca.survey.questionType': '问题类型',
    'pca.survey.questionReq': '问题 *',
    'pca.survey.enterYourQuestion': '输入您的问题',
    'pca.survey.options': '选项',
    'pca.survey.optionN': '选项 {n}',
    'pca.survey.addOption': '添加选项',
    'pca.survey.requiredQuestion': '必答问题',
    'pca.survey.addQuestion': '添加问题',
    'pca.survey.questionsCount': '问题（{count}）',
    'pca.survey.required': '必答',
    'pca.survey.creatingSurvey': '正在创建调查...',
    'pca.survey.preview': '预览',
    'pca.survey.details': '详情',
    'pca.survey.audience': '受众',
    'pca.survey.typeLabel': '类型：',
    'pca.survey.paid': '付费',
    'pca.survey.unpaid': '免费',
    'pca.survey.rewardLabel': '奖励：',
    'pca.survey.durationLabel': '时长：',
    'pca.survey.difficultyLabel': '难度：',
    'pca.survey.questionsLabel': '问题：',
    'pca.survey.fillToPreview': '填写调查详情以查看预览',
    'pca.survey.targetAll': '目标：{business} 的所有客户',
    'pca.survey.yourBusiness': '您的商家',
    'pca.survey.deadlineLabel': '截止日期：',
    'pca.survey.requiredQuestions': '{count} 个必答问题',
    'pca.survey.totalQuestions': '共添加 {count} 个问题',
    'pca.survey.surveyTips': '调查提示',
    'pca.survey.tip1': '保持问题清晰简洁',
    'pca.survey.tip2': '混合使用多种问题类型以提高参与度',
    'pca.survey.tip3': '根据调查长度提供适当的奖励',
    'pca.survey.tip4': '发布前测试您的调查',
    'pca.survey.tip5': '设定切合实际的截止日期',
  },
  ar: {
    // ---- ShowroomManager ----
    'pca.sm.productPublished': 'تم نشر المنتج',
    'pca.sm.correctionRequested': 'مطلوب تصحيح',
    'pca.sm.correctionAccepted': 'تم قبول التصحيح',
    'pca.sm.showroomRequiredHint': 'أنشئ صالة العرض قبل إضافة عناصر إلى المتجر.',
    'pca.sm.correctionAwaitingReview': 'تم إرسال التصحيح — بانتظار المراجعة',
    'pca.sm.correctionRequestedAt': 'تم الطلب في',
    'pca.sm.correctionEditHint': 'عدّل هذا الإدراج لمعالجة الطلب، ثم احفظ.',
    'pca.sm.correctionSubmittedHint': 'تم إرسال تحديثك. ستقوم Servisfy بمراجعته.',
    'pca.sm.productHidden': 'تم إخفاء المنتج',
    'pca.sm.productNowActive': '{name} نشط الآن.',
    'pca.sm.productNowHidden': '{name} مخفي الآن.',
    'pca.sm.updateFailed': 'فشل التحديث',
    'pca.sm.confirmDeleteProduct': 'حذف "{name}"؟ لا يمكن التراجع عن هذا الإجراء.',
    'pca.sm.productDeleted': 'تم حذف المنتج',
    'pca.sm.productWasRemoved': 'تمت إزالة {name}.',
    'pca.sm.deleteFailed': 'فشل الحذف',
    'pca.sm.formError': 'خطأ في النموذج',
    'pca.sm.formNotInit': 'لم تتم تهيئة بيانات النموذج بشكل صحيح.',
    'pca.sm.validationError': 'خطأ في التحقق',
    'pca.sm.fillRequiredFields': 'يرجى ملء جميع الحقول المطلوبة.',
    'pca.sm.authError': 'خطأ في المصادقة',
    'pca.sm.businessIdRequiredLogin': 'معرّف نشاط المستخدم التجاري مطلوب. يرجى تسجيل الدخول مرة أخرى.',
    'pca.sm.showroomUpdated': 'تم تحديث صالة العرض',
    'pca.sm.showroomUpdatedDesc': 'تم تحديث تفاصيل صالة العرض الخاصة بك بنجاح!',
    'pca.sm.showroomCreated': 'تم إنشاء صالة العرض',
    'pca.sm.showroomCreatedDesc': 'تم إنشاء صالة العرض الخاصة بك بنجاح!',
    'pca.sm.failedSaveShowroom': 'فشل حفظ صالة العرض. يرجى المحاولة مرة أخرى.',
    'pca.sm.productNameDescRequired': 'اسم المنتج ووصفه مطلوبان.',
    'pca.sm.categoryRequired': 'الفئة مطلوبة',
    'pca.sm.selectCategoryBeforeSaving': 'يرجى اختيار فئة المنتج قبل الحفظ.',
    'pca.sm.functionNotAvailable': 'الوظيفة غير متاحة',
    'pca.sm.productCreateFnUnavailable': 'وظيفة إنشاء المنتجات غير متاحة. يرجى تحديث الصفحة.',
    'pca.sm.productAddedTitle': 'تمت إضافة المنتج بنجاح',
    'pca.sm.productAddedDesc': 'تمت إضافة {name} إلى صالة العرض الخاصة بك وأصبح الآن مرئيًا في المنتجات والخدمات.',
    'pca.sm.errorAddingProduct': 'خطأ في إضافة المنتج',
    'pca.sm.failedAddProduct': 'فشل إضافة المنتج: {error}',
    'pca.sm.unknownErrorOccurred': 'حدث خطأ غير معروف',
    'pca.sm.unknownError': 'خطأ غير معروف',
    'pca.sm.tooManyImages': 'عدد كبير جدًا من الصور',
    'pca.sm.selectUpTo10': 'يرجى اختيار ما يصل إلى 10 صور إجمالاً.',
    'pca.sm.unsupportedFile': 'ملف غير مدعوم',
    'pca.sm.onlyImageTypes': '{name}: يُسمح فقط بصور JPEG أو PNG أو WebP.',
    'pca.sm.fileTooLarge': 'الملف كبير جدًا',
    'pca.sm.imageMaxSize': '{name}: يجب أن يكون حجم الصور 10 ميغابايت أو أقل.',
    'pca.sm.imagesUploaded': 'تم رفع الصور',
    'pca.sm.imagesAdded': 'تمت إضافة {count} صورة.',
    'pca.sm.uploadFailed': 'فشل الرفع',
    'pca.sm.couldNotUploadImage': 'تعذّر رفع الصورة.',
    'pca.sm.onlyVideoTypes': '{name}: يُسمح فقط بمقاطع فيديو MP4 أو MOV.',
    'pca.sm.videoMaxSize': '{name}: يجب أن يكون حجم مقاطع الفيديو 100 ميغابايت أو أقل.',
    'pca.sm.videoUploaded': 'تم رفع الفيديو',
    'pca.sm.productVideoAdded': 'تمت إضافة فيديو المنتج.',
    'pca.sm.couldNotUploadVideo': 'تعذّر رفع الفيديو.',
    'pca.sm.productUpdateFnUnavailable': 'وظيفة تحديث المنتجات غير متاحة. يرجى تحديث الصفحة.',
    'pca.sm.productUpdated': 'تم تحديث المنتج',
    'pca.sm.productUpdatedDesc': 'تم تحديث {name} بنجاح.',
    'pca.sm.errorUpdatingProduct': 'خطأ في تحديث المنتج',
    'pca.sm.failedUpdateProduct': 'فشل تحديث المنتج: {error}',
    'pca.sm.imagesUploadedTitle': 'تم رفع الصور',
    'pca.sm.imagesUploadedComingSoon': 'تم رفع {count} صورة. سيتوفّر إرفاق معرض صالة العرض قريبًا.',
    'pca.sm.uploadFailedTitle': 'فشل الرفع',
    'pca.sm.couldNotUploadImages': 'تعذّر رفع الصور. يرجى المحاولة مرة أخرى.',
    'pca.sm.showroomNotAvailable': 'صالة العرض غير متاحة',
    'pca.sm.showroomDataNotLoaded': 'لم يتم تحميل بيانات صالة العرض. يرجى تحديث الصفحة والمحاولة مرة أخرى.',
    'pca.sm.publicProfilePreview': 'معاينة الملف العام',
    'pca.sm.showingPreview': 'جارٍ عرض معاينة ملف صالة العرض العام الخاص بك في نافذة جديدة.',
    'pca.sm.previewBlocked': 'تم حظر المعاينة',
    'pca.sm.popupBlocked': 'تم حظر النافذة المنبثقة. صالة العرض الخاصة بك متاحة ويمكن للعملاء الوصول إليها.',
    'pca.sm.showroomDataNotAvailable': 'بيانات صالة العرض غير متاحة. يرجى تحديث الصفحة.',
    'pca.sm.editModeEnabled': 'تم تفعيل وضع التحرير',
    'pca.sm.editModeDesc': "يمكنك الآن تحديث أوصاف وتفاصيل صالة العرض الخاصة بك. لا تنسَ النقر على \"{action}\" عند الانتهاء.",
    'pca.sm.replyRequired': 'الرد مطلوب',
    'pca.sm.enterReplyMessage': 'يرجى إدخال رسالة رد.',
    'pca.sm.inquiryNotFound': 'الاستفسار غير موجود',
    'pca.sm.couldNotFindInquiry': 'تعذّر العثور على الاستفسار للرد عليه.',
    'pca.sm.replyFnUnavailable': 'وظيفة الرد غير متاحة. يرجى تحديث الصفحة.',
    'pca.sm.businessIdRequiredReplies': 'معرّف النشاط التجاري مطلوب لإرسال الردود. يرجى التحديث والمحاولة مرة أخرى.',
    'pca.sm.replySent': 'تم إرسال الرد بنجاح',
    'pca.sm.replySentDesc': 'تم إرسال ردك إلى {customer}. تم تحديث الحالة إلى "تم الرد". سيتم إغلاق مربع الحوار خلال 3 ثوانٍ.',
    'pca.sm.errorSendingReply': 'خطأ في إرسال الرد',
    'pca.sm.failedSendReply': 'فشل إرسال الرد: {error}',
    'pca.sm.responseRequired': 'الرد مطلوب',
    'pca.sm.enterResponseMessage': 'يرجى إدخال رسالة رد.',
    'pca.sm.reviewNotFound': 'المراجعة غير موجودة',
    'pca.sm.couldNotFindReview': 'تعذّر العثور على المراجعة للرد عليها.',
    'pca.sm.responseFnUnavailable': 'وظيفة الرد غير متاحة. يرجى تحديث الصفحة.',
    'pca.sm.businessIdRequiredResponses': 'معرّف النشاط التجاري مطلوب لنشر الردود. يرجى التحديث والمحاولة مرة أخرى.',
    'pca.sm.responsePosted': 'تم نشر الرد بنجاح',
    'pca.sm.responsePostedDesc': 'تم نشر ردك على {customer}. تم تحديث الحالة إلى "تم الرد". سيتم إغلاق مربع الحوار خلال 3 ثوانٍ.',
    'pca.sm.errorPostingResponse': 'خطأ في نشر الرد',
    'pca.sm.failedPostResponse': 'فشل نشر الرد: {error}',
    'pca.sm.addressRequired': 'العنوان مطلوب',
    'pca.sm.enterAddressLookup': 'يرجى إدخال عنوان للبحث عن الموقع.',
    'pca.sm.locationFound': 'تم العثور على الموقع',
    'pca.sm.locationVerifiedUpdated': 'تم التحقق من الموقع وتحديثه.',
    'pca.sm.locationError': 'خطأ في الموقع',
    'pca.sm.failedFindLocation': 'تعذّر العثور على الموقع. يرجى التحقق من العنوان والمحاولة مرة أخرى.',
    'pca.sm.creating': 'جارٍ الإنشاء...',
    'pca.sm.chat': 'محادثة',
    'pca.sm.inAppCalls': 'مكالمات داخل التطبيق',
    'pca.sm.noAddressProvided': 'لم يتم تقديم عنوان',
    'pca.sm.contactForPrice': 'تواصل لمعرفة السعر',
    'pca.sm.productVideoTitle': 'فيديو المنتج',
    'pca.sm.unpublish': 'إلغاء النشر',
    'pca.sm.publish': 'نشر',
    'pca.sm.addNewProduct': 'إضافة منتج جديد',
    'pca.sm.addShowroomItem': 'إضافة عنصر إلى المعرض',
    'pca.sm.editShowroomItem': 'تعديل عنصر المعرض',
    'pca.sm.updateItemInfo': 'تحديث معلومات العنصر',
    'pca.sm.noItemsYet': 'لا توجد عناصر بعد',
    'pca.sm.addShowroomItemDesc': 'انشر خدمة أو منتجًا في معرضك العام.',
    'pca.sm.itemTypeReq': 'نوع العنصر *',
    'pca.sm.itemTypeService': 'خدمة',
    'pca.sm.itemTypeProduct': 'منتج',
    'pca.sm.itemNameReq': 'اسم العنصر *',
    'pca.sm.serviceNameReq': 'اسم الخدمة *',
    'pca.sm.itemImagesOptional': 'الصور (اختياري)',
    'pca.sm.uploadToShowroom': 'الرفع إلى صالة العرض',
    'pca.sm.uploadShowroomImages': 'رفع صور صالة العرض',
    'pca.sm.addPhotosGallery': 'أضف صورًا إلى معرض صالة العرض الخاصة بك',
    'pca.sm.dragDropImages': 'اسحب الصور وأفلتها هنا، أو انقر للتصفح',
    'pca.sm.selectFiles': 'اختيار الملفات',
    'pca.sm.uploadAndClose': 'رفع وإغلاق',
    'pca.sm.viewPublicProfile': 'عرض الملف العام',
    'pca.sm.customerInquiries': 'استفسارات العملاء',
    'pca.sm.performanceTips': 'نصائح الأداء',
    'pca.sm.addMoreImages': 'إضافة المزيد من الصور',
    'pca.sm.images40more': 'المنتجات التي تحتوي على 3 صور أو أكثر تحصل على مشاهدات أكثر بنسبة 40%',
    'pca.sm.uploadImages': 'رفع الصور',
    'pca.sm.updateDescriptions': 'تحديث الأوصاف',
    'pca.sm.detailedDescImprove': 'الأوصاف التفصيلية تحسّن الظهور في البحث',
    'pca.sm.editDescriptions': 'تحرير الأوصاف',
    'pca.sm.respondToReviews': 'الرد على المراجعات',
    'pca.sm.activeEngagement': 'التفاعل النشط يبني ثقة العملاء',
    'pca.sm.viewReviews': 'عرض المراجعات',
    'pca.sm.createNewShowroom': 'إنشاء صالة عرض جديدة',
    'pca.sm.quickCreateShowroom': 'أنشئ صالة عرض لنشاطك التجاري بسرعة',
    'pca.sm.create': 'إنشاء',
    'pca.sm.addProductDesc': 'أضف منتجًا أو خدمة إلى صالة العرض الخاصة بك',
    'pca.sm.productNameReq': 'اسم المنتج *',
    'pca.sm.enterProductName': 'أدخل اسم المنتج',
    'pca.sm.descriptionReq': 'الوصف *',
    'pca.sm.describeProductService': 'صف منتجك أو خدمتك',
    'pca.sm.price': 'السعر',
    'pca.sm.categoryReq': 'الفئة *',
    'pca.sm.selectCategory': 'اختر فئة…',
    'pca.sm.productImages': 'صور المنتج',
    'pca.sm.uploading': 'جارٍ الرفع…',
    'pca.sm.uploadProductImages': 'رفع صور المنتج',
    'pca.sm.upTo10Images': 'يُسمح بما يصل إلى 10 صور',
    'pca.sm.recommendedFormat': 'موصى به: 1200x800 بكسل، صيغة JPG/PNG',
    'pca.sm.imagesUploadedCount': 'تم رفع {count} صورة',
    'pca.sm.productVideo': 'فيديو المنتج',
    'pca.sm.optional': '(اختياري)',
    'pca.sm.uploadProductVideo': 'رفع فيديو المنتج',
    'pca.sm.oneVideoPerProduct': 'فيديو واحد لكل منتج',
    'pca.sm.videoFormatMax': 'MP4 أو MOV، حتى 100 ميغابايت',
    'pca.sm.videoUploadedLabel': 'تم رفع الفيديو',
    'pca.sm.showroomAnalytics': 'تحليلات صالة العرض',
    'pca.sm.detailedMetrics': 'مقاييس أداء تفصيلية لصالة العرض الخاصة بك',
    'pca.sm.visitors': 'الزوار',
    'pca.sm.inquiries': 'الاستفسارات',
    'pca.sm.analyticsNotAvailable': 'التحليلات التفصيلية لصالة العرض غير متاحة بعد.',
    'pca.sm.manageInquiries': 'إدارة أسئلة العملاء وطلباتهم',
    'pca.sm.replied': 'تم الرد',
    'pca.sm.from': 'من:',
    'pca.sm.yourReply': 'ردك:',
    'pca.sm.repliedOn': 'تم الرد في:',
    'pca.sm.unknown': 'غير معروف',
    'pca.sm.typeReply': 'اكتب ردك هنا...',
    'pca.sm.sending': 'جارٍ الإرسال...',
    'pca.sm.sendReply': 'إرسال الرد',
    'pca.sm.reply': 'رد',
    'pca.sm.replyAgain': 'الرد مرة أخرى',
    'pca.sm.noInquiriesYet': 'لا توجد استفسارات من العملاء بعد',
    'pca.sm.customerReviews': 'مراجعات العملاء',
    'pca.sm.respondFeedback': 'الرد على ملاحظات العملاء ومراجعاتهم',
    'pca.sm.responded': 'تم الرد',
    'pca.sm.new': 'جديد',
    'pca.sm.yourResponse': 'ردك:',
    'pca.sm.respondedOn': 'تم الرد في:',
    'pca.sm.thankCustomer': 'اشكر العميل وقدّم ردك...',
    'pca.sm.posting': 'جارٍ النشر...',
    'pca.sm.postResponse': 'نشر الرد',
    'pca.sm.updateResponse': 'تحديث الرد',
    'pca.sm.respond': 'رد',
    'pca.sm.noReviewsYet': 'لا توجد مراجعات من العملاء بعد',
    'pca.sm.editProduct': 'تحرير المنتج',
    'pca.sm.updateProductInfo': 'تحديث معلومات المنتج',
    'pca.sm.describeProduct': 'صف منتجك...',
    'pca.sm.currentImagesReplace': 'الصور الحالية ({count}) — رفع صور جديدة يستبدل هذه الصور',
    'pca.sm.replaceProductVideo': 'استبدال فيديو المنتج',
    'pca.sm.newVideoUploaded': 'تم رفع فيديو جديد',
    'pca.sm.currentVideo': 'الفيديو الحالي',
    'pca.sm.removeVideo': 'إزالة الفيديو',
    'pca.sm.updateProduct': 'تحديث المنتج',

    // ---- CreateSurvey ----
    'pca.survey.surveyDetails': 'تفاصيل الاستطلاع',
    'pca.survey.surveyTitleReq': 'عنوان الاستطلاع *',
    'pca.survey.enterTitle': 'أدخل عنوان الاستطلاع',
    'pca.survey.descriptionReq': 'الوصف *',
    'pca.survey.describeSurvey': 'صف موضوع هذا الاستطلاع',
    'pca.survey.surveyTypeReq': 'نوع الاستطلاع *',
    'pca.survey.paidSurvey': 'استطلاع مدفوع',
    'pca.survey.unpaidSurvey': 'استطلاع غير مدفوع',
    'pca.survey.reward': 'المكافأة',
    'pca.survey.communityPoints': 'نقاط المجتمع',
    'pca.survey.duration': 'المدة',
    'pca.survey.durationExample': '5-10 دقائق',
    'pca.survey.difficulty': 'الصعوبة',
    'pca.survey.easy': 'سهل',
    'pca.survey.medium': 'متوسط',
    'pca.survey.advanced': 'متقدم',
    'pca.survey.deadlineReq': 'الموعد النهائي *',
    'pca.survey.addQuestions': 'إضافة أسئلة',
    'pca.survey.questionType': 'نوع السؤال',
    'pca.survey.questionReq': 'السؤال *',
    'pca.survey.enterYourQuestion': 'أدخل سؤالك',
    'pca.survey.options': 'الخيارات',
    'pca.survey.optionN': 'الخيار {n}',
    'pca.survey.addOption': 'إضافة خيار',
    'pca.survey.requiredQuestion': 'سؤال إلزامي',
    'pca.survey.addQuestion': 'إضافة سؤال',
    'pca.survey.questionsCount': 'الأسئلة ({count})',
    'pca.survey.required': 'إلزامي',
    'pca.survey.creatingSurvey': 'جارٍ إنشاء الاستطلاع...',
    'pca.survey.preview': 'معاينة',
    'pca.survey.details': 'التفاصيل',
    'pca.survey.audience': 'الجمهور',
    'pca.survey.typeLabel': 'النوع:',
    'pca.survey.paid': 'مدفوع',
    'pca.survey.unpaid': 'غير مدفوع',
    'pca.survey.rewardLabel': 'المكافأة:',
    'pca.survey.durationLabel': 'المدة:',
    'pca.survey.difficultyLabel': 'الصعوبة:',
    'pca.survey.questionsLabel': 'الأسئلة:',
    'pca.survey.fillToPreview': 'املأ تفاصيل الاستطلاع لرؤية المعاينة',
    'pca.survey.targetAll': 'الهدف: جميع عملاء {business}',
    'pca.survey.yourBusiness': 'نشاطك التجاري',
    'pca.survey.deadlineLabel': 'الموعد النهائي:',
    'pca.survey.requiredQuestions': '{count} سؤال إلزامي',
    'pca.survey.totalQuestions': 'تمت إضافة {count} سؤال إجمالاً',
    'pca.survey.surveyTips': 'نصائح الاستطلاع',
    'pca.survey.tip1': 'اجعل الأسئلة واضحة وموجزة',
    'pca.survey.tip2': 'استخدم مزيجًا من أنواع الأسئلة لزيادة التفاعل',
    'pca.survey.tip3': 'قدّم مكافآت مناسبة لطول الاستطلاع',
    'pca.survey.tip4': 'اختبر استطلاعك قبل نشره',
    'pca.survey.tip5': 'حدّد مواعيد نهائية واقعية',
  },
};

export default pagesCompleteATranslations;
